'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var reactRouterDom = require('react-router-dom');
var reactRedux = require('react-redux');
var themes = require('web-ui-components/lib/utilities/themes');
var reactRouter = require('react-router');
var layout = require('web-ui-components/lib/global/layout');
var redux = require('redux');
var cards = require('web-ui-components/lib/organisms/cards');
var buttons = require('web-ui-components/lib/atoms/buttons');
var headings = require('web-ui-components/lib/typography/headings');
var reselect = require('reselect');
var modals = require('web-ui-components/lib/organisms/modals');
var text = require('web-ui-components/lib/atoms/text');
var PropTypes = _interopDefault(require('prop-types'));
var panels = require('web-ui-components/lib/molecules/panels');
var forms = require('web-ui-components/lib/atoms/forms');
var iconography = require('web-ui-components/lib/atoms/iconography');
var moment = _interopDefault(require('moment'));
var accordions = require('web-ui-components/lib/molecules/accordions');
var navigation = require('web-ui-components/lib/documents/navigation');
var takeovers = require('web-ui-components/lib/organisms/takeovers');
var navigation$1 = require('web-ui-components/lib/molecules/navigation');
var buttons$1 = require('web-ui-components/lib/molecules/buttons');
var tile = require('web-ui-components/lib/molecules/tile');
var cards$1 = require('web-ui-components/lib/molecules/cards');
var body = require('web-ui-components/lib/typography/body');
var content$1 = require('web-ui-components/lib/layout/content');
var thunk = _interopDefault(require('redux-thunk'));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var PreferenceCard = function (_a) {
    var getContent = _a.getContent, onUpdatePreferencesClick = _a.onUpdatePreferencesClick;
    return (React__default.createElement(cards.Card, null,
        React__default.createElement(headings.SectionHeading, null, getContent("preferencesTitle")),
        React__default.createElement("p", null, getContent("preferencesText")),
        React__default.createElement(buttons.Button, { onClick: onUpdatePreferencesClick, display: "primary" }, getContent("preferenceUpdateButton"))));
};

var mapPropsToBrand = function (props) {
    return props.session.brand.toUpperCase() === "DYB" ? "b" : props.session.brand;
};
var withContent = function (content, mapPropsToBrand) { return function (WrappedComponent) {
    return /** @class */ (function (_super) {
        __extends(WithContent, _super);
        function WithContent(props) {
            var _this = _super.call(this, props) || this;
            _this.getContent = _this.getContent.bind(_this);
            return _this;
        }
        WithContent.prototype.getContent = function (key) {
            var brand = mapPropsToBrand(this.props).toUpperCase();
            if (content[brand]) {
                return content[brand][key] || content.default[key] || "";
            }
            return content.default[key] || "";
        };
        WithContent.prototype.render = function () {
            return React__default.createElement(WrappedComponent, __assign({}, this.props, { getContent: this.getContent }));
        };
        return WithContent;
    }(React.Component));
}; };

var CB = {
	mobileStatementsFAQs: "https://native/exit/faqs/",
	statementsFAQs: "https://secure.cbonline.co.uk/help-support/internet-banking-help/",
	folderListTitle: "Your Clydesdale Bank letters and documents",
	description: "You can view your letters and documents as soon as they are created. They are available for up to 3 years. If you have a question about letters and documents, please call us."
};
var YB = {
	mobileStatementsFAQs: "https://native/exit/faqs/",
	statementsFAQs: "https://secure.ybonline.co.uk/help-support/internet-banking-help/",
	folderListTitle: "Your Yorkshire Bank letters and documents",
	description: "You can view your letters and documents as soon as they are created. They are available for up to 3 years. If you have a question about letters and documents, please call us."
};
var B = {
	mobileStatementsFAQs: "https://native/exit/faqs/",
	statementsFAQs: "https://www.youandb.co.uk/help/b-help/",
	folderListTitle: "Your B letters and documents",
	description: "You can view your letters and documents as soon as they are created. They are available for up to 3 years. If you have a question about letters and documents, please call us."
};
var VM = {
	mobileStatementsFAQs: "https://native/exit/faqs/",
	statementsFAQs: "https://uk.virginmoney.com/current-accounts/pca/questions-and-answers",
	folderListTitle: "Your letters and documents",
	description: "You can view your letters and documents as soon as they are created. They are available for up to 3 years. If you have a question about letters and documents, please call us."
};
var content = {
	"default": {
	statementCopy: "Looking for your online statements?",
	noDocumentsFilter: "No results due to filter(s) applied.",
	noDocuments: "No documents",
	fetchingDocuments: "Getting your documents...",
	backToParentFolder: "Back to parent folder",
	preferenceUpdateButton: "Update paper-free preferences",
	preferencesTitle: "Reduce your filing, shredding and recycling by going paper-free",
	preferencesText: "Switch to paper-free to receive statements, letters and documents digitally, rather than in the post. We'll notify you by email when a new paper-free letter or document is available, so you won't miss out.",
	accountDocumentsTitle: "Account documents",
	otherDocumentsTitle: "Other documents",
	accountSelectorTitle: "View or download statements for",
	accountNotShownTitle: "Got an account that isn't shown?",
	accountNotShownText: "Some types of accounts don’t currently have a paper-free statement option.",
	filterCopy: "Can't find the document you're looking for? Try adjusting the filters above.",
	faqCopy1: "See our ",
	faqLinkName: "FAQs",
	faqCopy2: " for details of paper-free documents available within internet and mobile banking.",
	nonPaperlessBlurb: "This account isn’t set up to go paper-free just yet. As soon as you’re able to go paper-free, we'll be in touch to let you know.",
	paperlessBlurb: "From time to time, we'll also send you letters and documents that aren't related to a specific account.",
	leaveConfirmationAutoTitle: "You haven't confirmed your preferences",
	leaveConfirmationManageTitle: "You haven't confirmed your changes yet",
	leaveConfirmationAutoBody: "Please, review and confirm your preferences before moving on.",
	leaveConfirmationManageBody: "You've changed your paper-free preferences but haven't confirmed them yet",
	leaveNoSaveButton: "Discard changes",
	leaveSaveButton: "Review and confirm changes"
},
	CB: CB,
	YB: YB,
	B: B,
	VM: VM
};

var TIME_FRAMES = [
    {
        displayName: "Last Month",
        months: 1
    },
    {
        displayName: "Last 3 Months",
        months: 3
    },
    {
        displayName: "Last 6 Months",
        months: 6
    },
    {
        displayName: "Last 12 Months",
        months: 12
    },
    {
        displayName: "Last 24 Months",
        months: 24
    },
    {
        displayName: "Last 36 Months",
        months: 36
    }
];
var DEVICE_ENVIRONMENT = {
    ios: "ios",
    android: "android",
    unknown: "unknown"
};

var ios = DEVICE_ENVIRONMENT.ios, android = DEVICE_ENVIRONMENT.android, unknown = DEVICE_ENVIRONMENT.unknown;
var mobileOS = function () {
    if (window.AndroidInterface) {
        return android;
    }
    if (window.webkit && window.webkit.messageHandlers) {
        return ios;
    }
    return unknown;
};
var downloadDocument = function (documentId, fileSize) {
    if (mobileOS() === android) {
        window.AndroidInterface.downloadDocument(documentId, fileSize);
    }
    else if (window.webkit) {
        window.webkit.messageHandlers.downloadDocument.postMessage(documentId, fileSize);
    }
    else {
        throw new Error("native interface not available");
    }
};
var isNativeView = function (window) {
    if (mobileOS() === android) {
        return true;
    }
    if (mobileOS() === ios) {
        return (window.webkit.messageHandlers.hasOwnProperty("webAppLoaded") && typeof window.webkit.messageHandlers.webAppLoaded.postMessage === "function");
    }
    return false;
};
var setBackButtonData = function (backButtonData) {
    if (window.AndroidInterface) {
        window.AndroidInterface.setBackButtonData(backButtonData);
    }
    else if (window.webkit) {
        window.webkit.messageHandlers.setBackButtonData.postMessage(backButtonData);
    }
    else {
        throw new Error("native interface not available");
    }
};
var setMessagesMetaData = function (data) {
    if (window.AndroidInterface) {
        window.AndroidInterface.setMessagesMetaData(JSON.stringify(data));
    }
    else if (window.webkit) {
        window.webkit.messageHandlers.setMessagesMetaData.postMessage(data);
    }
    else {
        throw new Error("native interface not available");
    }
};
var navigateToPreferences = function () {
    window.location.href = "https://native/exit/paperPreferences";
};
var navigateToDigitalStatements = function (accountId) {
    window.location.href = "https://native/exit/statements/" + accountId;
};

var native = /*#__PURE__*/Object.freeze({
    __proto__: null,
    mobileOS: mobileOS,
    downloadDocument: downloadDocument,
    isNativeView: isNativeView,
    setBackButtonData: setBackButtonData,
    setMessagesMetaData: setMessagesMetaData,
    navigateToPreferences: navigateToPreferences,
    navigateToDigitalStatements: navigateToDigitalStatements
});

var backButtonData = {
    back_button: {
        title: "Back",
        visible: true,
        back_arrow_visible: false
    },
    nav_bar_hidden: false
};
var withNativeBridge = function (_a) {
    var window = _a.window;
    return function (WrappedComponent) {
        return /** @class */ (function (_super) {
            __extends(WithNativeBridge, _super);
            function WithNativeBridge(props) {
                var _this = _super.call(this, props) || this;
                _this.state = {
                    isWebView: isNativeView(window),
                    setMessagesMetaData: setMessagesMetaData
                };
                return _this;
            }
            WithNativeBridge.prototype.render = function () {
                return (React__default.createElement(WrappedComponent, __assign({ setBackButton: function (url, accessToken) { return setBackButtonData(__assign({}, backButtonData, { url: url, access_token: accessToken })); }, navigateToPreferences: navigateToPreferences, navigateToDigitalStatements: navigateToDigitalStatements }, this.state, this.props)));
            };
            return WithNativeBridge;
        }(React.Component));
    };
};

var PreferenceCardContainer = /** @class */ (function (_super) {
    __extends(PreferenceCardContainer, _super);
    function PreferenceCardContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.handleUpdatePreferencesClick = _this.handleUpdatePreferencesClick.bind(_this);
        return _this;
    }
    PreferenceCardContainer.prototype.handleUpdatePreferencesClick = function () {
        this.props.isWebView ? this.props.navigateToPreferences() : window.top.postMessage("goToPreferences", "*");
    };
    PreferenceCardContainer.prototype.render = function () {
        var getContent = this.props.getContent;
        return React__default.createElement(PreferenceCard, { onUpdatePreferencesClick: this.handleUpdatePreferencesClick, getContent: getContent });
    };
    return PreferenceCardContainer;
}(React.Component));
var PreferenceCardContainer$1 = redux.compose(reactRouter.withRouter, withContent(content, mapPropsToBrand), withNativeBridge(window))(PreferenceCardContainer);

var buildApiActionTypes = function (type) { return ({
    REQUEST: "@@async/" + type + "/REQUEST",
    RECEIVED: "@@async/" + type + "/RECEIVED",
    ERROR: "@@async/" + type + "/ERROR"
}); };

var buildApiActionCreator = function (actionTypes, apiCall) { return function (payload) { return function (dispatch, getState, dependencies) {
    dispatch({
        type: actionTypes.REQUEST,
        payload: payload
    });
    return apiCall(payload, dependencies, getState)
        .then(function (response) {
        dispatch({
            type: actionTypes.RECEIVED,
            payload: response
        });
        return response;
    })
        .catch(function (error) {
        // eslint-disable-next-line
        console.error(error);
        dispatch({
            type: actionTypes.ERROR,
            payload: error
        });
        return error;
    });
}; }; };

var GET_DOCUMENTS = buildApiActionTypes("GET_DOCUMENTS");
var getDocuments = buildApiActionCreator(GET_DOCUMENTS, function (_, _a) {
    var api = _a.api;
    return api.getDocuments();
});
var GET_DOCUMENT_BY_ID = buildApiActionTypes("GET_DOCUMENT_BY_ID");
var getDocumentById = buildApiActionCreator(GET_DOCUMENT_BY_ID, function (_a, _b) {
    var id = _a.id;
    var api = _b.api;
    return api.getDocumentById({ id: id });
});
var GET_DOCUMENT_BY_ID_NATIVE = "@@documents/native/GET_DOCUMENT_BY_ID";
var getDocumentByIdNative = function (documentId, fileSize) { return function (dispatch, _, dependencies) {
    dependencies.native.downloadDocument(documentId, fileSize);
    return dispatch({
        type: GET_DOCUMENT_BY_ID_NATIVE,
    });
}; };
var CLEAR_CURRENT_DOCUMENT = "CLEAR_CURRENT_DOCUMENT";
var clearCurrentDocument = function () { return function (dispatch) {
    dispatch({
        type: CLEAR_CURRENT_DOCUMENT,
    });
}; };

var actions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    GET_DOCUMENTS: GET_DOCUMENTS,
    getDocuments: getDocuments,
    GET_DOCUMENT_BY_ID: GET_DOCUMENT_BY_ID,
    getDocumentById: getDocumentById,
    GET_DOCUMENT_BY_ID_NATIVE: GET_DOCUMENT_BY_ID_NATIVE,
    getDocumentByIdNative: getDocumentByIdNative,
    CLEAR_CURRENT_DOCUMENT: CLEAR_CURRENT_DOCUMENT,
    clearCurrentDocument: clearCurrentDocument
});

var hasApiCallInProgress = function (state) { return state.documentManagement.api.callsInProgress.length > 0; };
var hasError = function (state) { return state.documentManagement.api.errors.length > 0; };
var getHistorySelector = function (state) { return state.documentManagement.api.history; };
var getCallsInProgress = function (state) { return state.documentManagement.api.callsInProgress; };
var getErrors = function (state) { return state.documentManagement.api.errors; };
var buildHasReceivedSelector = function (action) {
    return reselect.createSelector([getHistorySelector], function (history) { return history.some(function (response) { return response === action.RECEIVED; }); });
};
var buildHasApiCallInProgress = function (actionTypes) {
    var _a = actionTypes.REQUEST.split("/"), actionType = _a[1];
    return reselect.createSelector([getCallsInProgress], function (callsInProgress) { return callsInProgress.some(function (callInProgress) { return callInProgress === actionType; }); });
};
var buildHasError = function (actionTypes) {
    var _a = actionTypes.REQUEST.split("/"), actionType = _a[1];
    return reselect.createSelector([getErrors], function (errors) { return errors.some(function (error) { return error === actionType; }); });
};

var lense = function (keys) { return function (object) {
    return keys.reduce(function (result, currentKey) {
        if (result === undefined || result[currentKey] === undefined) {
            return undefined;
        }
        return result[currentKey];
    }, object);
}; };

var getAppTitle = lense(["client", "app_title"]);
var isAdvisor = function (clientContext) { return getAppTitle(clientContext) === "MEO"; };

var AdvisorContext = /** @class */ (function (_super) {
    __extends(AdvisorContext, _super);
    function AdvisorContext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AdvisorContext.prototype.render = function () {
        var _a = this.props, children = _a.children, hide = _a.hide, show = _a.show;
        var advisor = isAdvisor(this.context.clientContext);
        return (hide && advisor) || (show && !advisor) ? null : children;
    };
    AdvisorContext.contextTypes = {
        clientContext: PropTypes.shape({
            client: PropTypes.shape({
                app_title: PropTypes.string
            })
        })
    };
    return AdvisorContext;
}(React__default.Component));

var FilterSelect = function (_a) {
    var options = _a.options, value = _a.value, onChange = _a.onChange, disabled = _a.disabled;
    return (React__default.createElement(forms.Select, { options: options, "aria-name": "value", value: value, onChange: function (e) {
            onChange(e.target.value);
        }, disabled: disabled }));
};

var FilterCard = function (_a) {
    var onFilterChange = _a.onFilterChange, onApplyClick = _a.onApplyClick, accountsAndServices = _a.accountsAndServices, documentCategoryOptions = _a.documentCategoryOptions, dateRangeOptions = _a.dateRangeOptions, activeFilters = _a.activeFilters, onResetClick = _a.onResetClick, showReset = _a.showReset, disabled = _a.disabled;
    return (React__default.createElement(panels.ContrastingFormPanel, null,
        React__default.createElement(layout.FlexRow, null,
            React__default.createElement(layout.FlexColumn, { proportion: 1 },
                React__default.createElement(layout.BlockField, { className: "u-padding-top-1" },
                    React__default.createElement(text.TextBody, null, "Filter by:"))),
            React__default.createElement(layout.FlexColumn, { proportion: 3 },
                React__default.createElement(FilterSelect, { disabled: disabled, options: accountsAndServices, value: activeFilters.account, onChange: function (value) {
                        onFilterChange("account", value);
                    } })),
            React__default.createElement(layout.FlexColumn, { proportion: 3 },
                React__default.createElement(FilterSelect, { disabled: disabled, options: documentCategoryOptions, value: activeFilters.documentCategory, onChange: function (value) {
                        onFilterChange("documentCategory", value);
                    } })),
            React__default.createElement(layout.FlexColumn, { proportion: 3 },
                React__default.createElement(FilterSelect, { disabled: disabled, options: dateRangeOptions, value: activeFilters.dateRange, onChange: function (value) {
                        onFilterChange("dateRange", value);
                    } })),
            React__default.createElement(layout.FlexColumn, { proportion: 3 },
                React__default.createElement(buttons.Button, { disabled: disabled, className: "u-margin-left-2 apply-btn", width: "flush", display: "primary", onClick: onApplyClick }, "Apply"),
                showReset && (React__default.createElement(buttons.Button, { width: "flush", className: "reset-btn", onClick: onResetClick }, "Reset"))))));
};

var getModals = function (state) { return state.documentManagement.ui.modals; };
var getActiveFilters = function (state) { return state.documentManagement.ui.activeFilters; };
var createIsModalOpenSelector = function (id) {
    return reselect.createSelector([getModals], function (modals) { return modals[id]; });
};

var getDocumentsSelector = function (state) {
    var documentManagement = state.documentManagement;
    var meta = documentManagement.documents.meta;
    return meta;
};
var getDocumentAccountOrServiceSelector = function (state, props) {
    return getActiveFilters(state).account;
};
var getDocumentIdSelector = function (_, _a) {
    var documentId = _a.documentId;
    return documentId;
};
var onlyUnique = function (value, index, self) {
    return self.indexOf(value) === index;
};
// TODO move to utils
var onlyUniqueBy = function (lensFn) { return function (previousValue, currentValue) {
    return previousValue.find(function (value) { return lensFn(value) === lensFn(currentValue); }) ? previousValue : previousValue.concat([currentValue]);
}; };
var getDistinctCases = reselect.createSelector([getDocumentsSelector], function (documents) {
    return documents
        .reduce(function (cases, document) { return cases.concat(document.cases); }, [])
        .reduce(onlyUniqueBy(function (cse) { return cse.id; }), []);
} // TODO: naming
);
var getBlobForCurrentDocument = function (state) { return state.documentManagement.documents.currentDocument; };
var getDocumentById$1 = reselect.createSelector([getDocumentsSelector, getDocumentIdSelector], function (documents, documentId) { return documents.find(function (document) { return document.id === documentId; }); });
var getDocumentsWithAccountOrService = reselect.createSelector([getDocumentsSelector], function (documents) {
    return documents.map(function (document) {
        var accountOrService = "General";
        if (document.cases.length) {
            accountOrService = document.cases[0].id;
        }
        if (document.accounts.length) {
            accountOrService = document.accounts[0].number;
        }
        return __assign({}, document, { accountOrService: accountOrService });
    });
});
var getDocumentsByAccountOrService = reselect.createSelector([getDocumentsWithAccountOrService, getDocumentAccountOrServiceSelector], function (documents, account) {
    return account === "all.accounts"
        ? documents
        : documents.filter(function (document) {
            return document.accounts.find(function (instance) { return instance.number === account; }) || document.accountOrService.toLowerCase() === account.toLowerCase();
        });
});
var getDateRanges = reselect.createSelector([getDocumentsByAccountOrService], function (documents) {
    return TIME_FRAMES;
});
var getDocumentCategories = reselect.createSelector([getDocumentsSelector], function (documents) {
    return documents.reduce(function (categories, document) { return categories.concat(document.categories); }, []).filter(onlyUnique);
});
var getDocumentsByFilterCriteria = reselect.createSelector([getDocumentsSelector, getDocumentsByAccountOrService], function (documents, filtered) {
    return filtered;
});
var getUniqueAccounts = function (documents) {
    return documents.reduce(function (accounts, document) { return accounts.concat(document.accounts); }, []).filter(matchAccountPredicate);
};
var matchAccountPredicate = function (account, index, self) {
    return index === self.findIndex(function (item) { return item.display_name === account.display_name && item.number === account.number; });
};
var getDistinctAccounts = reselect.createSelector([getDocumentsSelector], getUniqueAccounts);
var getDistinctAccountsWithFilter = reselect.createSelector([getDocumentsByFilterCriteria], getUniqueAccounts);
var getGeneralDocuments = reselect.createSelector([getDocumentsByFilterCriteria], function (documents) { return documents.filter(function (document) { return document.accountOrService === "General"; }); });
var getAllAccounts = reselect.createSelector([getDocumentsSelector], function (documents) {
    return documents
        .reduce(function (accounts, document) { return accounts.concat(document.accounts); }, [])
        .filter(function (account, index, self) { return index === self.findIndex(function (item) { return item.number === account.number; }); });
});

var selector = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getDocumentsSelector: getDocumentsSelector,
    getDistinctCases: getDistinctCases,
    getBlobForCurrentDocument: getBlobForCurrentDocument,
    getDocumentById: getDocumentById$1,
    getDocumentsWithAccountOrService: getDocumentsWithAccountOrService,
    getDocumentsByAccountOrService: getDocumentsByAccountOrService,
    getDateRanges: getDateRanges,
    getDocumentCategories: getDocumentCategories,
    getDocumentsByFilterCriteria: getDocumentsByFilterCriteria,
    getDistinctAccounts: getDistinctAccounts,
    getDistinctAccountsWithFilter: getDistinctAccountsWithFilter,
    getGeneralDocuments: getGeneralDocuments,
    getAllAccounts: getAllAccounts
});

var RegexUtils = {
    getLastFourDigits: function (text) {
        var numDigits = 4;
        return String(text).substr(text.length - numDigits);
    }
};

var getLastFourDigits = RegexUtils.getLastFourDigits;
var getDateRangeOptions = reselect.createSelector(getDateRanges, function (dateRanges) {
    return dateRanges.map(function (dateRange) { return ({
        label: dateRange.displayName,
        value: dateRange.months.toString()
    }); });
});
var getDocumentCategoryOptions = reselect.createSelector(getDocumentCategories, function (documentCategories) { return [
    {
        label: "All document types",
        value: "all.documents"
    }
].concat(documentCategories.map(function (documentCategory) { return ({
    label: documentCategory,
    value: documentCategory
}); })); });
var getCasesOptions = reselect.createSelector(getDistinctCases, function (cases) { return cases.map(function (cse) { return ({
    label: cse.description + "  (" + cse.id + ")",
    value: cse.id
}); }).slice(); });
var getAccountOrServiceOptions = reselect.createSelector(getAllAccounts, function (accounts) { return accounts.map(function (account) {
    var friendlyName = account.display_name + " (ends " + getLastFourDigits(account.number) + ")";
    return {
        label: friendlyName,
        value: account.number
    };
}).slice(); });
var getAllOptions = function () { return [
    {
        label: "All accounts and services",
        value: "all.accounts"
    }
]; };
var getGeneralOptions = function () { return [
    {
        label: "General",
        value: "general"
    }
]; };
var getAllFilterOptions = reselect.createSelector([getAllOptions, getAccountOrServiceOptions, getCasesOptions, getGeneralOptions], function (allOptions, accountOrServiceOptions, casesOptions, generalOptions) {
    return allOptions.concat(accountOrServiceOptions, casesOptions, generalOptions);
});

var buildStandardActionCreator = function (actionType) { return [
    "@@documents/" + actionType,
    function (payload) { return ({
        type: "@@documents/" + actionType,
        payload: payload
    }); }
]; };

var _a, _b, _c, _d, _e;
var RESET_FILTERS = (_a = buildStandardActionCreator("RESET_FILTERS"), _a[0]), resetFilters = _a[1];
var SET_FILTER = (_b = buildStandardActionCreator("SET_FILTER"), _b[0]), setFilter = _b[1];
var SET_FILTERS = (_c = buildStandardActionCreator("SET_FILTERS"), _c[0]), setFilters = _c[1];
var OPEN_MODAL = (_d = buildStandardActionCreator("OPEN_MODAL"), _d[0]), openModal = _d[1];
var CLOSE_MODAL = (_e = buildStandardActionCreator("CLOSE_MODAL"), _e[0]), closeModal = _e[1];

var throttle = function (fn, wait) {
    var time = Date.now();
    return function () {
        if (time + wait - Date.now() < 0) {
            fn();
            time = Date.now();
        }
    };
};
var breakpoints = {
    xs: [0, 599],
    sm: [600, 959],
    md: [960, 1279],
    lg: [1280, 1919],
    xl: [1920, Infinity]
};
var calculateBreakPoint = function (width) {
    return Object.keys(breakpoints).reduce(function (prevValue, currentValue) {
        var breakpoint = breakpoints[currentValue];
        if (width >= breakpoint[0] && width <= breakpoint[1]) {
            return currentValue;
        }
        return prevValue;
    }, "xs");
};
var withBreakpoints = function (WrappedComponent) {
    return /** @class */ (function (_super) {
        __extends(WithBreakpoints, _super);
        function WithBreakpoints(props) {
            var _this = _super.call(this, props) || this;
            _this.handleResize = _this.handleResize.bind(_this);
            window.addEventListener("resize", throttle(_this.handleResize, 500));
            _this.state = {
                breakpoint: calculateBreakPoint(window.innerWidth),
                width: window.innerWidth
            };
            return _this;
        }
        WithBreakpoints.prototype.componentWillUnmount = function () {
            window.removeEventListener("resize", this.handleResize);
        };
        WithBreakpoints.prototype.handleResize = function () {
            this.setState({
                breakpoint: calculateBreakPoint(window.innerWidth)
            });
        };
        WithBreakpoints.prototype.render = function () {
            return React__default.createElement(WrappedComponent, __assign({ breakpoints: breakpoints }, this.state, this.props));
        };
        return WithBreakpoints;
    }(React__default.Component));
};
var BreakpointInternal = function (_a) {
    var _b = _a.min, min = _b === void 0 ? "xs" : _b, _c = _a.max, max = _c === void 0 ? "xl" : _c, width = _a.width, children = _a.children;
    return React__default.createElement("div", null, width >= breakpoints[min][0] && width <= breakpoints[max][1] ? children : null);
};
var Breakpoint = withBreakpoints(BreakpointInternal);

var MobileFilterCard = function (_a) {
    var onFilterChange = _a.onFilterChange, onApplyClick = _a.onApplyClick, accountsAndServices = _a.accountsAndServices, documentCategoryOptions = _a.documentCategoryOptions, dateRangeOptions = _a.dateRangeOptions, activeFilters = _a.activeFilters, onResetClick = _a.onResetClick, showReset = _a.showReset, disabled = _a.disabled;
    return (React__default.createElement("div", null,
        React__default.createElement(layout.Row, { className: "u-margin-top-2 u-margin-bottom-1" },
            React__default.createElement(layout.Column, { xs: 24 },
                React__default.createElement(FilterSelect, { disabled: disabled, options: accountsAndServices, value: activeFilters.account, onChange: function (value) {
                        onFilterChange("account", value);
                    } }))),
        React__default.createElement(layout.Row, { className: "u-margin-bottom-1" },
            React__default.createElement(layout.Column, { xs: 24 },
                React__default.createElement(FilterSelect, { disabled: disabled, options: documentCategoryOptions, value: activeFilters.documentCategory, onChange: function (value) {
                        onFilterChange("documentCategory", value);
                    } }))),
        React__default.createElement(layout.Row, { className: "u-margin-bottom-1" },
            React__default.createElement(layout.Column, { xs: 24 },
                React__default.createElement(FilterSelect, { disabled: disabled, options: dateRangeOptions, value: activeFilters.dateRange, onChange: function (value) {
                        onFilterChange("dateRange", value);
                    } }))),
        React__default.createElement(layout.Row, { className: "u-margin-bottom-2" },
            React__default.createElement(layout.Column, { xs: 24 },
                React__default.createElement(buttons.Button, { disabled: disabled, "aria-label": "Apply Filters", role: "button", "aria-pressed": !showReset, "aria-expanded": !showReset, width: "full", display: "secondary", onClick: onApplyClick }, "Apply"))),
        showReset && (React__default.createElement(layout.Row, { className: "u-margin-bottom-2" },
            React__default.createElement(layout.Column, { xs: 24 },
                React__default.createElement(buttons.Button, { disabled: disabled, "aria-label": "Reset Filters", role: "button", "aria-pressed": showReset, "aria-expanded": showReset, width: "full", display: "secondary", onClick: onResetClick }, "Reset"))))));
};

var createReducer = (function (handlers, initialState) { return function (state, action) {
    if (state === void 0) { state = initialState; }
    if (!handlers[action.type]) {
        return state;
    }
    return handlers[action.type](state, action);
}; });

var GET_PREFERENCES = buildApiActionTypes("GET_PREFERENCES");
var getPreferences = buildApiActionCreator(GET_PREFERENCES, function (_, _a) {
    var api = _a.api;
    return api.getPreferences();
});
var UPDATE_PREFERENCES = buildApiActionTypes("UPDATE_PREFERENCES");
var updatePreferences = buildApiActionCreator(UPDATE_PREFERENCES, function (preferences, _a) {
    var api = _a.api;
    return api.updatePreferences(preferences);
});

var PREFS_UPDATED_SUCCESSFULLY = "PREFS_UPDATED_SUCCESSFULLY";

var _a$1, _b$1, _c$1;
var initialState = {
    documentCategory: "all.documents",
    dateRange: "6",
    account: "all.accounts"
};
var filterhandlers = (_a$1 = {},
    _a$1[SET_FILTERS] = function (state, action) { return (__assign({}, state, action.payload.value)); },
    _a$1[SET_FILTER] = function (state, action) {
        var _a;
        return (__assign({}, state, (_a = {}, _a[action.payload.filter] = action.payload.value, _a)));
    },
    _a$1[RESET_FILTERS] = function (state, action) {
        return __assign({}, initialState);
    },
    _a$1);
var modalHandlers = (_b$1 = {},
    _b$1[CLOSE_MODAL] = function (state, action) {
        var _a;
        return (__assign({}, state, (_a = {}, _a[action.payload] = false, _a)));
    },
    _b$1[OPEN_MODAL] = function (state, action) {
        var _a;
        return (__assign({}, state, (_a = {}, _a[action.payload] = false, _a)));
    },
    _b$1[UPDATE_PREFERENCES.RECEIVED] = function (state) {
        var _a;
        return (__assign({}, state, (_a = {}, _a[PREFS_UPDATED_SUCCESSFULLY] = true, _a)));
    },
    _b$1);
var initialModalState = (_c$1 = {},
    _c$1[PREFS_UPDATED_SUCCESSFULLY] = false,
    _c$1);
var modalReducer = createReducer(modalHandlers, initialModalState);
var activeFiltersReducer = createReducer(filterhandlers, initialState);
var ui = redux.combineReducers({
    activeFilters: activeFiltersReducer,
    modals: modalReducer
});

var withFilterOpenAndClose = function (WrappedComponent) {
    return /** @class */ (function (_super) {
        __extends(WithOpenAndClose, _super);
        function WithOpenAndClose(props) {
            var _this = _super.call(this, props) || this;
            _this.state = {
                open: false
            };
            _this.handleOpenCloseClick = _this.handleOpenCloseClick.bind(_this);
            return _this;
        }
        WithOpenAndClose.prototype.handleOpenCloseClick = function () {
            this.setState({
                open: !this.state.open
            });
        };
        WithOpenAndClose.prototype.render = function () {
            return (React__default.createElement("div", null,
                React__default.createElement("div", { className: "u-full-width mobile-filter-card" },
                    React__default.createElement(buttons.Button, { width: "full", "aria-label": "Apply Filters", role: "button", "aria-pressed": this.state.open, "aria-expanded": this.state.open, className: "u-padding-0 u-flex-full-height", onClick: this.handleOpenCloseClick },
                        React__default.createElement(panels.ContrastingFormPanel, null,
                            React__default.createElement(layout.LeftAndRightAlignment, { leftNode: React__default.createElement(text.Title, { className: "u-margin-bottom-0", size: "h5" }, "Filters"), rightNode: React__default.createElement(iconography.Icon, { iconType: "SliderOutlineLarge" }) })))),
                this.state.open && React__default.createElement(WrappedComponent, __assign({}, this.props))));
        };
        return WithOpenAndClose;
    }(React__default.Component));
};

var MobileFilter = withFilterOpenAndClose(MobileFilterCard);
var FilterContainer = /** @class */ (function (_super) {
    __extends(FilterContainer, _super);
    function FilterContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            filters: __assign({}, initialState),
            filtersApplied: false
        };
        _this.onFilterChange = _this.onFilterChange.bind(_this);
        _this.handleApplyClick = _this.handleApplyClick.bind(_this);
        _this.handleResetClick = _this.handleResetClick.bind(_this);
        return _this;
    }
    FilterContainer.prototype.onFilterChange = function (filter, value) {
        var _a;
        // DEBTxCYBG - ongoing issue with computed properties in tsx
        // SEE issue: https://github.com/Microsoft/TypeScript/issues/13948
        // @ts-ignore
        this.setState({ filters: __assign({}, this.state.filters, (_a = {}, _a[filter] = value, _a)) });
    };
    FilterContainer.prototype.handleApplyClick = function () {
        this.props.setFilters(this.state.filters);
        if (!this.state.filtersApplied) {
            this.setState({ filtersApplied: true });
        }
    };
    FilterContainer.prototype.handleResetClick = function () {
        var _this = this;
        this.setState({
            filters: __assign({}, initialState),
            filtersApplied: false
        }, function () {
            _this.props.onResetClick(_this.state);
        });
    };
    FilterContainer.prototype.render = function () {
        var _a = this.props, dateRangeOptions = _a.dateRangeOptions, documentCategoryOptions = _a.documentCategoryOptions, breakpoint = _a.breakpoint, accountsAndServices = _a.accountsAndServices, disabled = _a.disabled;
        var mobileViews = ["xs", "sm"];
        var filterProps = {
            activeFilters: this.state.filters,
            onFilterChange: this.onFilterChange,
            onApplyClick: this.handleApplyClick,
            onResetClick: this.handleResetClick,
            accountsAndServices: accountsAndServices,
            dateRangeOptions: dateRangeOptions,
            documentCategoryOptions: documentCategoryOptions,
            showReset: this.state.filtersApplied,
            disabled: disabled
        };
        return mobileViews.some(function (size) { return size === breakpoint; }) ? React__default.createElement(MobileFilter, __assign({}, filterProps)) : React__default.createElement(FilterCard, __assign({}, filterProps));
    };
    return FilterContainer;
}(React.Component));
var mapStateToProps = function (state, _a) {
    var account = _a.account;
    return {
        accountsAndServices: getAllFilterOptions(state),
        dateRangeOptions: getDateRangeOptions(state, { account: account }),
        documentCategoryOptions: getDocumentCategoryOptions(state),
        activeFilters: getActiveFilters(state),
        disabled: hasApiCallInProgress(state) || hasError(state)
    };
};
var actionCreators = {
    setFilters: function (filterObj) {
        return setFilters({
            value: filterObj
        });
    },
    onResetClick: resetFilters
};
var FilterContainer$1 = reactRedux.connect(mapStateToProps, actionCreators)(withBreakpoints(FilterContainer));

var getDateRange = reselect.createSelector([getActiveFilters], function (activeFilters) { return activeFilters.dateRange; });
var getDocumentCategory = reselect.createSelector([getActiveFilters], function (activeFilters) { return activeFilters.documentCategory; });
var getSession = function (_, _a) {
    var session = _a.session;
    return session;
};
var getClient = function (_, _a) {
    var client = _a.client;
    return client;
};
var sanitiseUrl = function (url) { return url.replace(/\/$/, ""); };
var documentWithLocation = function (session, client, baseUrl) { return function (document) {
    var url = encodeURI(baseUrl + "/" + document.id + "#access_token=" + session.access_token + "&bank_id=" + session.bank_id + "&client_context=" + client.client.app_title + "&user_tracking_id=" + client.client.user_tracking_id + "&brandId=" + session.brand + "&state=" + session.state);
    return __assign({}, document, { documentLocation: url });
}; };
var getDownloadErrorRoute = reselect.createSelector([getSession, getClient], function (session, client) {
    var baseUrl = "" + window.location.origin + window.location.pathname;
    return baseUrl + "/error#access_token=" + session.access_token + "&bank_id=" + session.bank_id + "&client_context=" + client.client.app_title + "&user_tracking_id=" + client.client.user_tracking_id + "&brandId=" + session.brand + "&state=" + session.state;
});
var getFilteredDocuments = reselect.createSelector([getDocumentsByAccountOrService, getDateRange, getDocumentCategory, getSession, getClient], function (documents, dateRange, documentCategory, session, client) {
    var baseUrl = "" + window.location.origin + window.location.pathname;
    var sanitisedUrl = sanitiseUrl(baseUrl);
    var docs = documents
        .filter(function (document) {
        return ((document.categories.some(function (category) { return category === documentCategory; }) || documentCategory === "all.documents") &&
            moment()
                .subtract(dateRange, "months")
                .isBefore(moment(document.created)));
    })
        .map(documentWithLocation(session, client, sanitisedUrl));
    return docs;
});
var getHasDocuments = reselect.createSelector([getDocumentsSelector], function (documents) { return documents.length > 0; });

var groupsWithDocuments = function (groups, documents) {
    return groups
        .map(function (group) {
        return __assign({}, group, { documents: documents.filter(function (_a) {
                var accountOrService = _a.accountOrService;
                return accountOrService === group.id;
            }) });
    })
        .filter(function (group) { return group.documents.length; });
};
var getGroupsByTitle = reselect.createSelector([groupsWithDocuments], function (groups) { return groups; });
var getAccountType = reselect.createSelector([getActiveFilters], function (activeFilters) { return activeFilters.account; });
var getGroupListFromAccounts = reselect.createSelector([getDistinctAccountsWithFilter, getAccountType], function (accounts, accountOrService) {
    var mappedAccounts = accounts.map(function (account) { return ({
        title: account.display_name,
        subTitle: account.number,
        id: account.number,
        filterCriteria: function (document) { return document.accounts.some(function (acc) { return acc.number === account.number; }); }
    }); });
    if (accountOrService === "all.accounts") {
        return mappedAccounts;
    }
    return mappedAccounts.filter(function (account) { return account.title === accountOrService || account.subTitle === accountOrService; });
});
var getGroupListFromCases = reselect.createSelector([getDistinctCases, getAccountType], function (cases, accountOrService) {
    var mappedCases = cases.map(function (cse) { return ({
        title: cse.description,
        subTitle: cse.id,
        id: cse.id,
        filterCriteria: function (document) { return document.cases.some(function (currentCase) { return currentCase.id === cse.id; }); }
    }); }).slice();
    return accountOrService === "all.accounts" ? mappedCases : mappedCases.filter(function (cse) { return cse.id === accountOrService; });
});
var getGroupFromGeneral = reselect.createSelector([getGeneralDocuments], function () { return [
    {
        title: "General",
        subTitle: "",
        id: "General",
        filterCriteria: function (document) { return document.accounts.length === 0 && document.cases.length === 0; }
    }
]; });

var withDocumentGroupList = function (groupSelector) { return function (WrappedComponent) {
    var DocumentGroupListContainer = /** @class */ (function (_super) {
        __extends(DocumentGroupListContainer, _super);
        function DocumentGroupListContainer(props) {
            return _super.call(this, props) || this;
        }
        DocumentGroupListContainer.prototype.render = function () {
            var _a = this.props, groups = _a.groups, match = _a.match;
            return React__default.createElement(WrappedComponent, __assign({ groups: groups, baseUrl: match.url }, this.props));
        };
        return DocumentGroupListContainer;
    }(React.Component));
    var mapStateToProps = function (state, _a) {
        var match = _a.match;
        var session = state.documentManagement.session;
        var client = state.documentManagement.clientContext;
        var documents = getFilteredDocuments(state, { client: client, session: session, match: match });
        var downloadErrorRoute = getDownloadErrorRoute(state, { client: client, session: session });
        var groups = getGroupsByTitle(groupSelector(state), documents);
        return {
            groups: groups,
            downloadErrorRoute: downloadErrorRoute
        };
    };
    return redux.compose(reactRouter.withRouter, reactRedux.connect(mapStateToProps))(DocumentGroupListContainer);
}; };

var Document = function (_a) {
    var id = _a.id, type = _a.type, created = _a.created, categories = _a.categories, user_visible = _a.user_visible, onClick = _a.onClick;
    return (React__default.createElement(layout.Row, null,
        React__default.createElement(layout.Column, { xs: 24 },
            React__default.createElement(navigation.DocumentLinkPlate, { date: new Date(created), linkText: type, subtitle: categories.join(","), onClick: function () { return onClick(id); } }),
            React__default.createElement(AdvisorContext, { show: true },
                React__default.createElement(text.BadgeLabel, { text: user_visible ? "visible to customer" : "bank internal document" })))));
};

var DocumentList = function (_a) {
    var documents = _a.documents, onDocumentClick = _a.onDocumentClick;
    return (React__default.createElement("ul", { className: "c-document-list" }, documents.map(function (document) { return (React__default.createElement("li", { key: document.id, className: "u-component-spacing" },
        React__default.createElement(Document, __assign({ baseUrl: "", onClick: onDocumentClick }, document)))); })));
};

var supportsIEDownload = function () { return window.navigator && window.navigator.msSaveOrOpenBlob; };
var isSafari = function () { return /.*Version.*Safari.*/.test(navigator.userAgent); };

var DocumentListContainer = /** @class */ (function (_super) {
    __extends(DocumentListContainer, _super);
    function DocumentListContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
        _this.performBrowserAction = _this.performBrowserAction.bind(_this);
        return _this;
    }
    DocumentListContainer.prototype.handleDocumentClick = function (documentId) {
        var _a = this.props, isWebView = _a.isWebView, documents = _a.documents;
        var currentDocument = documents.find(function (document) { return document.id === documentId; });
        if (isWebView) {
            this.props.getDocumentByIdNative(documentId, currentDocument.size);
        }
        else {
            this.performBrowserAction(currentDocument);
        }
    };
    DocumentListContainer.prototype.performBrowserAction = function (document) {
        var _this = this;
        if (supportsIEDownload()) {
            this.props
                .getDocumentById(document.id)
                .then(function (blob) {
                window.navigator.msSaveOrOpenBlob(blob, document.name);
            })
                .catch(function (_) {
                window.open(_this.props.downloadErrorRoute);
            });
        }
        else {
            window.open(document.documentLocation);
        }
    };
    DocumentListContainer.prototype.render = function () {
        var documents = this.props.documents;
        return React__default.createElement(DocumentList, { documents: documents, onDocumentClick: this.handleDocumentClick });
    };
    return DocumentListContainer;
}(React.Component));
var mapStateToProps$1 = function (state) {
    return {
        retrievedDocument: getBlobForCurrentDocument(state)
    };
};
var mapDispatchToProps = function (dispatch) {
    return {
        clearCurrentDocument: clearCurrentDocument,
        getDocumentById: function (id) {
            return dispatch(getDocumentById({ id: id }));
        },
        getDocumentByIdNative: function (id, fileSize) { return dispatch(getDocumentByIdNative(id, fileSize)); }
    };
};
var DocumentListContainer$1 = redux.compose(withNativeBridge(window), reactRedux.connect(mapStateToProps$1, mapDispatchToProps))(DocumentListContainer);

var formatCurrency = function (amount) {
    var formattedValue = amount.value.toLocaleString("en-GB", { minimumFractionDigits: 2 });
    var prefix = amount.currency === "GBP" ? "£" : "";
    var postfix = amount.currency !== "GBP" ? amount.currency : "";
    return ("" + prefix + formattedValue + " " + postfix).trim();
};
var formatAccountAndSortCodeToPipe = function (accountWithSortCode) {
    var expectedDashIndex = 6;
    if (accountWithSortCode.charAt(expectedDashIndex) === "-") {
        var _a = accountWithSortCode.split("-"), sortCode = _a[0], accountNumber = _a[1];
        return formatSortCode(sortCode) + " | " + accountNumber;
    }
    return accountWithSortCode;
};
var formatSortCode = function (sortCode) {
    return sortCode !== null
        ? // eslint-disable-next-line no-magic-numbers
            sortCode.slice(0, 2) + "-" + sortCode.slice(2, 4) + "-" + sortCode.slice(-2)
        : null;
};

var GroupTitle = function (_a) {
    var title = _a.title, subTitle = _a.subTitle;
    return (React__default.createElement("div", null,
        React__default.createElement(text.Title, { className: "u-display-inline u-margin-right-2", size: "h5" }, title),
        formatAccountAndSortCodeToPipe(subTitle)));
};

var DocumentGroupList = /** @class */ (function (_super) {
    __extends(DocumentGroupList, _super);
    function DocumentGroupList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentGroupList.prototype.render = function () {
        var _a = this.props, groups = _a.groups, downloadErrorRoute = _a.downloadErrorRoute;
        return (React__default.createElement(accordions.Accordion, { expanded: 0 }, groups.map(function (_a) {
            var title = _a.title, documents = _a.documents, subTitle = _a.subTitle;
            return (React__default.createElement(accordions.AccordionItem, { key: title, title: React__default.createElement(GroupTitle, { title: title, subTitle: subTitle }) },
                React__default.createElement(DocumentListContainer$1, { documents: documents, downloadErrorRoute: downloadErrorRoute })));
        })));
    };
    return DocumentGroupList;
}(React.Component));

var AccountListContainer = withDocumentGroupList(getGroupListFromAccounts)(DocumentGroupList);
var CaseListContainer = withDocumentGroupList(getGroupListFromCases)(DocumentGroupList);
var GeneralListContainer = withDocumentGroupList(getGroupFromGeneral)(DocumentGroupList);
var ComposeListItem = function (_a) {
    var content = _a.content, children = _a.children;
    return (React__default.createElement(layout.Row, null,
        React__default.createElement(layout.Column, { xs: 24 },
            React__default.createElement("br", null),
            React__default.createElement(headings.SectionHeading, null, content)),
        React__default.createElement(layout.Column, { xs: 24 }, children)));
};
var ComposeListItems = function (_a) {
    var documents = _a.documents, hasError = _a.hasError, hasAccountsList = _a.hasAccountsList, getContent = _a.getContent, hasCaseList = _a.hasCaseList, hasGeneralList = _a.hasGeneralList, hasDocuments = _a.hasDocuments;
    if (!documents.length && !hasError) {
        return (React__default.createElement(layout.Row, null,
            React__default.createElement(layout.Column, { xs: 24 },
                React__default.createElement(cards.Card, { className: "u-margin-top-2", type: "warning" },
                    React__default.createElement(text.TextBody, null, hasDocuments ? getContent("noDocumentsFilter") : getContent("noDocuments"))))));
    }
    return (React__default.createElement("div", null,
        hasAccountsList && (React__default.createElement(ComposeListItem, { content: getContent("accountDocumentsTitle") },
            React__default.createElement(AccountListContainer, null))),
        (hasCaseList || hasGeneralList) && (React__default.createElement(ComposeListItem, { content: getContent("otherDocumentsTitle") },
            React__default.createElement("div", null,
                React__default.createElement(CaseListContainer, null),
                React__default.createElement(GeneralListContainer, null))))));
};

var NativeLink = function (_a) {
    var url = _a.url, text = _a.text, onClick = _a.onClick;
    return (React__default.createElement("a", { onClick: function (e) {
            e.preventDefault();
            if (typeof onClick === "function") {
                onClick();
            }
            window.location.href = url;
        }, href: "#" }, text));
};

var Error$1 = function (_a) {
    var onRetryClick = _a.onRetryClick, label = _a.label, hasError = _a.hasError, children = _a.children;
    return !hasError ? (React__default.createElement("div", null, children)) : (React__default.createElement("div", { id: "error" },
        React__default.createElement(layout.Row, null,
            React__default.createElement(layout.Column, { xs: 24, className: "u-component-spacing u-flex u-flex-justify-content-center" },
                React__default.createElement("span", null, label))),
        React__default.createElement(layout.Row, { className: "u-flex u-flex-justify-content-center" },
            React__default.createElement(layout.Column, { xs: 24, sm: 12, md: 8, lg: 4 },
                React__default.createElement(buttons.Button, { id: "retry-button", width: "full", display: "primary", onClick: onRetryClick }, "Retry")))));
};

var InsetLoader = function (loaderProps) { return (React__default.createElement(takeovers.LoadingLocalTakeover, __assign({}, loaderProps),
    React__default.createElement(layout.BlockField, { className: "u-padding-10" }))); };

var ListViewCard = /** @class */ (function (_super) {
    __extends(ListViewCard, _super);
    function ListViewCard(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            modalOpen: false
        };
        _this.handleNativeClick = _this.handleNativeClick.bind(_this);
        return _this;
    }
    ListViewCard.prototype.handleNativeClick = function () {
        var _this = this;
        // DEBT x CYBG
        //TODO: This is a patch until native guys can find a solution
        // May involve additional eventing to listen for from WebView.
        var timeout = 5000;
        this.setState({ modalOpen: true }, function () {
            return setTimeout(function () {
                _this.setState({ modalOpen: false });
            }, timeout);
        });
    };
    ListViewCard.prototype.render = function () {
        var _a = this.props, documents = _a.documents, getContent = _a.getContent, hasAccountsList = _a.hasAccountsList, hasCaseList = _a.hasCaseList, hasGeneralList = _a.hasGeneralList, hasDocuments = _a.hasDocuments, isLoading = _a.isLoading, hasError = _a.hasError, onRetryClick = _a.onRetryClick, account = _a.account;
        var ios = DEVICE_ENVIRONMENT.ios, android = DEVICE_ENVIRONMENT.android, unknown = DEVICE_ENVIRONMENT.unknown;
        return (React__default.createElement(cards.Card, null,
            React__default.createElement(headings.SubHeading, null, getContent("folderListTitle")),
            React__default.createElement(layout.Row, null,
                React__default.createElement(layout.Column, { xs: 24 },
                    React__default.createElement(text.TextBody, null,
                        React__default.createElement("span", null, getContent("description"))))),
            React__default.createElement(layout.Row, null,
                React__default.createElement(AdvisorContext, { hide: true },
                    React__default.createElement(layout.Column, { xs: 24 },
                        React__default.createElement(text.TextBody, null,
                            React__default.createElement("span", null,
                                " ",
                                getContent("statementCopy"),
                                " "),
                            React__default.createElement(reactRouterDom.Link, { to: "/digital-statements/select-account" }, "View and download statements"))))),
            React__default.createElement(layout.Row, null,
                React__default.createElement(layout.Column, { xs: 24 },
                    React__default.createElement(Error$1, { onRetryClick: onRetryClick, label: "No documents have loaded.", hasError: hasError },
                        React__default.createElement(FilterContainer$1, { account: account })))),
            isLoading ? (React__default.createElement(InsetLoader, { className: "u-padding-top-6 u-padding-bottom-6 u-margin-top-2", show: isLoading, title: getContent("fetchingDocuments") })) : (React__default.createElement(ComposeListItems, { hasError: hasError, documents: documents, hasAccountsList: hasAccountsList, getContent: getContent, hasCaseList: hasCaseList, hasGeneralList: hasGeneralList, isLoading: isLoading, hasDocuments: hasDocuments })),
            React__default.createElement(modals.Loader, { isOpen: this.state.modalOpen }),
            React__default.createElement(layout.Row, { className: "u-margin-top-2" },
                React__default.createElement(layout.Column, { xs: 24 },
                    !hasError && React__default.createElement(text.TextBody, null, getContent("filterCopy")),
                    React__default.createElement(text.TextBody, null,
                        getContent("faqCopy1"),
                        (mobileOS() === android || mobileOS() === ios) && (React__default.createElement(NativeLink, { onClick: this.handleNativeClick, url: "" + getContent("mobileStatementsFAQs") + getContent("statementsFAQs"), text: getContent("faqLinkName") })),
                        mobileOS() === unknown && (React__default.createElement("a", { href: getContent("statementsFAQs"), target: "__blank" }, getContent("faqLinkName"))),
                        getContent("faqCopy2"))))));
    };
    return ListViewCard;
}(React__default.Component));

var ListView = /** @class */ (function (_super) {
    __extends(ListView, _super);
    function ListView(props) {
        return _super.call(this, props) || this;
    }
    ListView.prototype.render = function () {
        var _a = this.props, onRetryClick = _a.onRetryClick, isLoading = _a.isLoading, hasError = _a.hasError, getContent = _a.getContent, documents = _a.documents, hasGeneralList = _a.hasGeneralList, hasAccountsList = _a.hasAccountsList, hasCaseList = _a.hasCaseList, hasDocuments = _a.hasDocuments;
        return (React__default.createElement(ListViewCard, { hasGeneralList: hasGeneralList, hasAccountsList: hasAccountsList, hasCaseList: hasCaseList, documents: documents, getContent: getContent, isLoading: isLoading, hasError: hasError, hasDocuments: hasDocuments, onRetryClick: onRetryClick }));
    };
    return ListView;
}(React__default.Component));

var _a$2;
var handlers = (_a$2 = {},
    _a$2[GET_DOCUMENTS.RECEIVED] = function (state, action) {
        return __assign({}, state, { meta: action.payload.documents });
    },
    _a$2[GET_DOCUMENT_BY_ID.RECEIVED] = function (state, action) { return (__assign({}, state, { currentDocument: action.payload })); },
    _a$2[CLEAR_CURRENT_DOCUMENT] = function (state, _) { return (__assign({}, state, { currentDocument: null })); },
    _a$2);
var initialState$1 = {
    meta: [],
    currentDocument: null
};
var documents = createReducer(handlers, initialState$1);

var GET_ACCOUNTS = buildApiActionTypes("GET_ACCOUNTS");
var getAccounts = buildApiActionCreator(GET_ACCOUNTS, function (_, _a) {
    var api = _a.api;
    return api.getAccounts();
});

var _a$3;
var handlers$1 = (_a$3 = {},
    _a$3[GET_ACCOUNTS.RECEIVED] = function (_, action) { return action.payload.accounts; },
    _a$3);
var initialState$2 = [];
var accounts = createReducer(handlers$1, initialState$2); // TODO: types

var _a$4;
var handlers$2 = (_a$4 = {},
    _a$4[GET_PREFERENCES.RECEIVED] = function (state, action) { return action.payload; },
    _a$4[UPDATE_PREFERENCES.RECEIVED] = function (state, action) { return (__assign({}, state, action.payload)); },
    _a$4);
var initialState$3 = {
    communication_preferences: [
        {
            accounts: [],
            type: "Paperless",
            value: "Y"
        }
    ]
};
var preferences = createReducer(handlers$2, initialState$3);

var _a$5;
var RESET_ERRORS = (_a$5 = buildStandardActionCreator("@@async/RESET_ERRORS"), _a$5[0]), resetErrors = _a$5[1];

var callsInProgressReducer = function (state, action) {
    if (state === void 0) { state = []; }
    if (!action.type.includes("@@async")) {
        return state;
    }
    var _a = action.type.split("/"), actionType = _a[1];
    var _b = action.type.split("/"), requestLifecycleStage = _b[2];
    if (requestLifecycleStage === "REQUEST") {
        return state.concat([actionType]);
    }
    return state.slice().filter(function (t) { return t !== actionType; });
};
var errorsReducer = function (state, action) {
    if (state === void 0) { state = []; }
    if (action.type === RESET_ERRORS) {
        return [];
    }
    if (!action.type.includes("@@async")) {
        return state;
    }
    var _a = action.type.split("/"), requestLifecycleStage = _a[2];
    var _b = action.type.split("/"), actionType = _b[1];
    if (requestLifecycleStage === "REQUEST") {
        return state.filter(function (err) { return err !== actionType; });
    }
    if (requestLifecycleStage !== "ERROR") {
        return state;
    }
    return state.concat([actionType]);
};
var historyReducer = function (state, action) {
    if (state === void 0) { state = []; }
    if (!action.type.includes("@@async")) {
        return state;
    }
    return state.concat([action.type]);
};
var api = redux.combineReducers({
    callsInProgress: callsInProgressReducer,
    errors: errorsReducer,
    history: historyReducer
});

var createStandardReducer = function (name, initialState) {
    var _a;
    var reducerName = name.toUpperCase();
    var _b = buildStandardActionCreator("SET_" + reducerName), setActionType = _b[0], set = _b[1];
    var handlers = (_a = {},
        _a[setActionType] = function (_, action) {
            return action.payload;
        },
        _a);
    var actionCreators = {
        set: set
    };
    var reducer = createReducer(handlers, initialState);
    return [reducer, actionCreators];
};

var buildEnv = function () {
    var getBrowserVersion = function () { return navigator.appVersion || navigator.vendor || window.opera; };
    var getPlatform = function () { return navigator.platform || window.opera; };
    var getUserLocale = function () { return navigator.userLanguage || navigator.language || navigator.browserLanguage || navigator.systemLanguage; };
    return {
        platform_version: getBrowserVersion(),
        make: getPlatform(),
        locale: getUserLocale(),
        platform: "WEB"
    };
};
var buildClient = function (appTitle) { return ({
    user_tracking_id: "",
    app_title: appTitle,
    app_package_name: "WEB",
    app_version_code: "5.0",
    app_version_name: "0.8"
}); };
var buildClientContext = function (appTitle) { return ({
    client: buildClient(appTitle),
    env: buildEnv()
}); };

var _a$6;
var initialSession = {
    access_token: "",
    bank_id: "",
    brand: "",
    state: "",
};
var initaialClientContext = buildClientContext("");
var initialState$4 = {
    accounts: [],
    documents: {
        meta: [],
        currentDocument: null,
    },
    session: initialSession,
    clientContext: initaialClientContext,
    api: {
        callsInProgress: [],
        errors: [],
        history: [],
    },
    ui: {
        activeFilters: {
            documentCategory: "all.documents",
            dateRange: "6",
            account: "all.accounts",
        },
        modals: (_a$6 = {},
            _a$6[PREFS_UPDATED_SUCCESSFULLY] = false,
            _a$6),
    },
    preferences: {
        communication_preferences: [
            {
                accounts: [],
                type: "Paperless",
                value: "Y",
            },
        ],
    },
};
var _b$2 = createStandardReducer("session", initialSession), session = _b$2[0], sessionActions = _b$2[1];
var _c$2 = createStandardReducer("clientContext", initaialClientContext), clientContext = _c$2[0], clientContextActions = _c$2[1];
var reducer = redux.combineReducers({
    accounts: accounts,
    documents: documents,
    api: api,
    ui: ui,
    session: session,
    clientContext: clientContext,
    preferences: preferences,
});

var actionCreators$1 = {
    setSession: sessionActions.set,
    setClientContext: clientContextActions.set
};
var withSessionInit = function (WrappedComponent) {
    return reactRedux.connect(null, actionCreators$1)(/** @class */ (function (_super) {
        __extends(WithSessionInit, _super);
        function WithSessionInit(props) {
            var _this = _super.call(this, props) || this;
            var session = props.session, setSession = props.setSession, client = props.client, setClientContext = props.setClientContext;
            setSession(session);
            setClientContext(client);
            return _this;
        }
        WithSessionInit.prototype.render = function () {
            return React__default.createElement(WrappedComponent, __assign({}, this.props));
        };
        return WithSessionInit;
    }(React.Component)));
};

var ListViewContainer = /** @class */ (function (_super) {
    __extends(ListViewContainer, _super);
    function ListViewContainer(props) {
        var _this = _super.call(this, props) || this;
        props.getDocuments();
        return _this;
    }
    ListViewContainer.prototype.render = function () {
        var _a = this.props, isLoading = _a.isLoading, hasError = _a.hasError, getContent = _a.getContent, documents = _a.documents, hasAccountsList = _a.hasAccountsList, hasCaseList = _a.hasCaseList, hasGeneralList = _a.hasGeneralList, hasDocuments = _a.hasDocuments;
        return (React__default.createElement(ListView, { hasGeneralList: hasGeneralList, isLoading: isLoading, documents: documents, hasError: hasError, hasCaseList: hasCaseList, hasAccountsList: hasAccountsList, onRetryClick: this.props.getDocuments, getContent: getContent, hasDocuments: hasDocuments }));
    };
    return ListViewContainer;
}(React.Component));
var hasApiCallInProgress$1 = buildHasApiCallInProgress(GET_DOCUMENTS);
var hasError$1 = buildHasError(GET_DOCUMENTS);
// TODO: generalise
var mapStateToProps$2 = function (state) {
    var session = state.documentManagement.session;
    var client = state.documentManagement.clientContext;
    var groupListFromAccounts = getGroupListFromAccounts(state, {});
    var documents = getFilteredDocuments(state, { client: client, session: session });
    var groupListGeneral = getGeneralDocuments(state, {});
    var caseGroups = getGroupsByTitle(getGroupListFromCases(state), documents);
    return {
        isLoading: hasApiCallInProgress$1(state),
        hasError: hasError$1(state),
        documents: documents,
        hasDocuments: getHasDocuments(state),
        hasAccountsList: !!groupListFromAccounts.length,
        hasCaseList: caseGroups.length,
        hasGeneralList: !!groupListGeneral.length
    };
};
var actionCreator = {
    getDocuments: getDocuments
};
var ListViewContainer$1 = redux.compose(reactRedux.connect(mapStateToProps$2, actionCreator), withSessionInit, withContent(content, mapPropsToBrand))(ListViewContainer);

var handlePrint = function (url) {
    var w = window.open(url, "Print Document", "resizable, scrollbars");
    w.addEventListener("load", function () { return w.print(); });
};
var DocumentViewHeader = function (_a) {
    var url = _a.url, documentId = _a.documentId;
    return (React__default.createElement(cards.Card, null,
        React__default.createElement(layout.Row, null,
            React__default.createElement(layout.Column, { xs: 24 },
                React__default.createElement(buttons$1.ButtonGroup, null,
                    React__default.createElement("a", { href: url, download: "document-" + documentId + ".pdf" },
                        React__default.createElement(buttons.Button, { display: "primary" },
                            "Download",
                            React__default.createElement(iconography.Icon, { iconType: "DownloadSolidLarge", className: "c-a-button__icon" }))),
                    React__default.createElement("a", { href: "" + "javascript:;", onClick: function () { return handlePrint(url); } },
                        React__default.createElement(buttons.Button, { display: "primary" },
                            "Print",
                            React__default.createElement(iconography.Icon, { iconType: "PrinterOutlineLarge", className: "c-a-button__icon" }))))))));
};

var DocumentFailedToLoadError = function (_a) {
    var onCloseClick = _a.onCloseClick, brand = _a.brand;
    var brandId = brand.toLowerCase();
    brandId = brandId === "dyb" ? "b" : brandId;
    return (React__default.createElement(layout.PageLayout, null,
        React__default.createElement(layout.HeaderSection, { bankId: brandId }),
        React__default.createElement(layout.Container, { size: "md", className: "u-padding-3" },
            React__default.createElement(tile.Tile, { type: "warning", className: "u-background-color-white u-padding-2 u-margin-top-6", isBordered: true },
                React__default.createElement(text.Title, { size: "h5" }, "Sorry, something has gone wrong in the background. We are unable to retrieve your document."),
                React__default.createElement(text.TextBody, null, "Please try again later."),
                React__default.createElement(layout.Row, { className: "u-flex-justify-content-center u-margin-top-2" },
                    React__default.createElement(buttons.Button, { width: "flush", display: "primary", onClick: onCloseClick }, "Back to your letters and documents"))))));
};

var DocumentView = /** @class */ (function (_super) {
    __extends(DocumentView, _super);
    function DocumentView(props) {
        var _this = _super.call(this, props) || this;
        _this.handleBackClick = function () {
            _this.props.history.goBack();
        };
        _this.handleCloseClick = function () {
            window.close();
        };
        _this.state = { objectUrl: null };
        return _this;
    }
    DocumentView.prototype.componentDidMount = function () {
        this.props.getDocumentById({ id: this.props.documentId });
    };
    DocumentView.prototype.componentDidUpdate = function () {
        var blob = this.props.blob;
        if (!this.state.objectUrl && blob) {
            var objectUrl = URL.createObjectURL(blob);
            this.setState({ objectUrl: objectUrl });
        }
    };
    DocumentView.prototype.componentWillUnmount = function () {
        this.props.clearCurrentDocument();
        if (this.state.objectUrl) {
            URL.revokeObjectURL(this.state.objectUrl);
        }
    };
    DocumentView.prototype.render = function () {
        if (this.props.hasError) {
            return React__default.createElement(DocumentFailedToLoadError, { onCloseClick: this.handleCloseClick, brand: this.props.brand.toLowerCase() });
        }
        return (React__default.createElement("div", null,
            React__default.createElement(modals.Loader, { isOpen: this.props.isLoading, title: "Please Wait", body: "Downloading..." }),
            React__default.createElement(AdvisorContext, { show: true },
                React__default.createElement(cards.Card, null,
                    React__default.createElement(layout.Row, null,
                        React__default.createElement(navigation$1.BackButton, { onClick: this.handleBackClick })))),
            isSafari() ? React__default.createElement(DocumentViewHeader, { documentId: this.props.documentId, url: this.state.objectUrl }) : null,
            React__default.createElement("div", { className: "c-pdf-container" }, this.state.objectUrl ? React__default.createElement("embed", { className: "c-pdf-viewer", type: "application/pdf", src: this.state.objectUrl }) : React__default.createElement("div", null))));
    };
    return DocumentView;
}(React__default.Component));
var getDocumentErrorSelector = buildHasError(GET_DOCUMENT_BY_ID);
var mapStateToProps$3 = function (state, _a) {
    var match = _a.match, location = _a.location, session = _a.session;
    return ({
        blob: getBlobForCurrentDocument(state),
        documentId: match.params.documentId,
        isLoading: hasApiCallInProgress(state),
        hasError: getDocumentErrorSelector(state),
        brand: session.brand
    });
};
var actionCreators$2 = {
    getDocumentById: getDocumentById,
    clearCurrentDocument: clearCurrentDocument
};
var DocumentView$1 = reactRedux.connect(mapStateToProps$3, actionCreators$2)(DocumentView);

var ErrorCard = function (_a) {
    var onRetryClick = _a.onRetryClick, label = _a.label, hasError = _a.hasError, children = _a.children, title = _a.title;
    return (React__default.createElement(cards.Card, null,
        React__default.createElement(headings.SubHeading, null, title),
        React__default.createElement(Error$1, { onRetryClick: onRetryClick, label: label, hasError: hasError }, children)));
};

var AccountSelector = function (_a) {
    var accounts = _a.accounts, onAccountClick = _a.onAccountClick, onBackClick = _a.onBackClick, onRetryClick = _a.onRetryClick, isLoading = _a.isLoading, hasError = _a.hasError, getContent = _a.getContent, breakpoint = _a.breakpoint;
    var title = !hasError ? getContent("accountSelectorTitle") : "";
    var full = 24;
    var partial = 16;
    var smallBps = ["xs", "sm"];
    var columnWidth = smallBps.some(function (size) { return size === breakpoint; }) ? full : partial;
    return (React__default.createElement(ErrorCard, { onRetryClick: onRetryClick, label: "No accounts have loaded.", hasError: hasError, title: title },
        isLoading && React__default.createElement(InsetLoader, { title: "Loading statements", show: isLoading }),
        React__default.createElement(layout.Row, null, accounts.map(function (account) { return (React__default.createElement(layout.Column, { xs: columnWidth, className: "u-component-spacing", key: account.id },
            React__default.createElement(cards$1.AccountSummaryLinkCard, { accountAvailable: account.shouldShowAvailableBalance && account.availableBalance, accountBalance: account.currentBalance, accountName: account.name, onClick: function () { return onAccountClick(account); }, accountNumber: account.accountNumber, sortcode: account.sortCode }))); })),
        React__default.createElement(layout.Row, null,
            React__default.createElement(layout.Column, { xs: 24 },
                React__default.createElement(text.Title, { size: "h5" }, getContent("accountNotShownTitle")),
                React__default.createElement(text.TextBody, null, getContent("accountNotShownText")))),
        React__default.createElement(layout.Row, null,
            React__default.createElement(layout.Column, { xs: 24 },
                React__default.createElement(buttons.Button, { id: "back-button", display: "secondary", onClick: onBackClick }, "Back")))));
};

// TODO: make action_available key a constant
var getDigitalAccountsSelector = function (state) {
    return state.documentManagement.accounts.filter(function (account) { return account.actions_available["/account/statements/read"] === true; });
};

var byBalanceType = function (type) { return function (balance) { return balance.type === type; }; };
var getAccountName = function (account) { return account.metadata.display_name || account.product.name; };
var getAccountNumber = function (account) { return account.number.split("-")[1]; };
var getSortCode = function (account) { return account.number.split("-")[0]; };
var getForamttedDigitalAccountsSelector = reselect.createSelector([getDigitalAccountsSelector], function (accounts) {
    return accounts.map(function (account) { return ({
        id: account.id,
        availableBalance: account.balances ? formatCurrency(account.balances.find(byBalanceType("available")).amount) : "",
        currentBalance: account.balances ? formatCurrency(account.balances.find(byBalanceType("current")).amount) : "",
        name: getAccountName(account),
        accountNumber: getAccountNumber(account),
        sortCode: formatSortCode(getSortCode(account)),
        shouldShowAvailableBalance: account.actions_available["/account/balance/available"]
    }); });
});

var AccountSelectorContainer = /** @class */ (function (_super) {
    __extends(AccountSelectorContainer, _super);
    function AccountSelectorContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.handleBackClick = _this.handleBackClick.bind(_this);
        _this.handleAccountClick = _this.handleAccountClick.bind(_this);
        if (props.hasReceivedAccounts === false) {
            props.getAccounts();
        }
        return _this;
    }
    AccountSelectorContainer.prototype.handleAccountClick = function (account) {
        var message = "goToDigitalStatements/" + account.id;
        // TODO: create abstraction around window.postMessage, use dependency injection to make it available
        this.props.isWebView ? this.props.navigateToDigitalStatements(account.id) : window.top.postMessage(message, "*");
    };
    AccountSelectorContainer.prototype.handleBackClick = function () {
        var history = this.props.history;
        history.goBack();
    };
    AccountSelectorContainer.prototype.render = function () {
        var _a = this.props, accounts = _a.accounts, isLoading = _a.isLoading, hasError = _a.hasError, getContent = _a.getContent, breakpoint = _a.breakpoint;
        return (React__default.createElement(AccountSelector, { accounts: accounts, breakpoint: breakpoint, onAccountClick: this.handleAccountClick, onBackClick: this.handleBackClick, onRetryClick: this.props.getAccounts, hasError: hasError, isLoading: isLoading, getContent: getContent }));
    };
    return AccountSelectorContainer;
}(React.Component));
var actionCreators$3 = {
    getAccounts: getAccounts
};
var hasReceivedAccountsSelector = buildHasReceivedSelector(GET_ACCOUNTS);
var hasApiCallInProgress$2 = buildHasApiCallInProgress(GET_ACCOUNTS);
var hasError$2 = buildHasError(GET_ACCOUNTS);
var mapStateToProps$4 = function (state) {
    var accounts = getForamttedDigitalAccountsSelector(state);
    return {
        accounts: accounts,
        session: state.documentManagement.session,
        hasReceivedAccounts: hasReceivedAccountsSelector(state),
        isLoading: hasApiCallInProgress$2(state),
        hasError: hasError$2(state)
    };
};
var AccountSelectorContainer$1 = redux.compose(reactRedux.connect(mapStateToProps$4, actionCreators$3), reactRouter.withRouter, withBreakpoints, withContent(content, mapPropsToBrand), withNativeBridge(window))(AccountSelectorContainer);

var PreferenceInfo = function () { return (React__default.createElement(layout.Row, null,
    React__default.createElement(layout.Column, { xs: 24 },
        React__default.createElement(headings.SectionHeading, null, "Important information")),
    React__default.createElement(layout.Column, { xs: 24 },
        React__default.createElement(text.TextBody, null,
            "By confirming you want to go paper-free for any of your accounts below, you'll be agreeing to receive communications digitally",
            "."),
        React__default.createElement(text.TextBody, null, "All digital communications will be available to view and download within internet banking and the mobile app."),
        React__default.createElement(text.TextBody, null, "We may continue to send you some statements or documents by post."),
        React__default.createElement(text.TextBody, null, "If you currently receive communications from us in Braille, large text or audio these will no longer be delivered if paper is switched off."),
        React__default.createElement(text.TextBody, null, "For joint account holders, you are choosing this option for both of you," +
            " so it’s worth checking that the other account holder is happy with this first."),
        React__default.createElement(text.TextBody, null, "For more information please view our FAQs in the Help section.")))); };

var makePaperFree = function (values) {
    return Object.keys(values).reduce(function (newValues, key) {
        var _a;
        return (__assign({}, newValues, (_a = {}, _a[key] = __assign({}, values[key], { active: true }), _a)));
    }, {});
};

var PreferenceOption = function (_a) {
    var onChange = _a.onChange, option = _a.option, name = _a.name;
    return (React__default.createElement(content$1.ToggleButtonPanel, { labelText: option.title, subText: option.subTitle, isChecked: option.active, id: name, toggleLabelLeft: "Paper-free", checkboxOnClick: function (val) {
            var _a;
            onChange((_a = {},
                _a[name] = __assign({}, option, { active: !option.active }),
                _a));
        } }, option.blurb && (option.active || !option.accountSpecific) && (React__default.createElement(body.StandardBody, { isFlush: true },
        React__default.createElement("p", null, option.blurb)))));
};

var PreferenceOptionList = function (_a) {
    var options = _a.options, onPreferenceChange = _a.onPreferenceChange, disabled = _a.disabled;
    return (React__default.createElement("div", null,
        React__default.createElement(takeovers.LoadingLocalTakeover, { title: "Updating paper-free preferences", show: disabled }, Object.keys(options).map(function (optionKey) {
            var option = options[optionKey];
            return React__default.createElement(PreferenceOption, { key: optionKey, name: optionKey, option: option, onChange: onPreferenceChange });
        }))));
};

var FormTitle = function (_a) {
    var onPaperFreeClick = _a.onPaperFreeClick, isUpdatingPreferences = _a.isUpdatingPreferences, isFullyPaperless = _a.isFullyPaperless;
    return (React__default.createElement("div", null,
        React__default.createElement(Breakpoint, { min: "md" },
            React__default.createElement(layout.LeftAndRightAlignment, { leftNode: React__default.createElement(headings.SectionHeading, null, "Manage your paper-free preferences"), rightNode: React__default.createElement(buttons.Button, { display: "secondary", onClick: onPaperFreeClick, disabled: isFullyPaperless || isUpdatingPreferences }, "Go paper-free for all") }))));
};

var withBeforeUnload = function (shouldRenderConfirmation) { return function (WrappedComponent) {
    return /** @class */ (function (_super) {
        __extends(WithBeforeUnload, _super);
        function WithBeforeUnload(props) {
            return _super.call(this, props) || this;
        }
        WithBeforeUnload.prototype.componentDidMount = function () {
            if (shouldRenderConfirmation(this.props)) {
                window.addEventListener("beforeunload", WithBeforeUnload.beforeUnload);
            }
        };
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
        WithBeforeUnload.beforeUnload = function (event) {
            event.preventDefault();
            event.returnValue = "";
            return "";
        };
        WithBeforeUnload.prototype.render = function () {
            return React__default.createElement(WrappedComponent, __assign({}, this.props));
        };
        WithBeforeUnload.prototype.componentDidUpdate = function (prevProps) {
            if (shouldRenderConfirmation(this.props) === shouldRenderConfirmation(prevProps)) {
                return;
            }
            if (shouldRenderConfirmation(this.props)) {
                window.addEventListener("beforeunload", WithBeforeUnload.beforeUnload);
                return;
            }
            window.removeEventListener("beforeunload", WithBeforeUnload.beforeUnload);
        };
        WithBeforeUnload.prototype.componentWillUnmount = function () {
            window.removeEventListener("beforeunload", WithBeforeUnload.beforeUnload);
        };
        return WithBeforeUnload;
    }(React.Component));
}; };

var RenderFormInternal = function (_a) {
    var values = _a.values, handleChange = _a.handleChange, handleSubmit = _a.handleSubmit, isDirty = _a.isDirty, isUpdatingPreferences = _a.isUpdatingPreferences, autoCheck = _a.autoCheck, getContent = _a.getContent;
    return (React__default.createElement("form", null,
        React__default.createElement(layout.Row, { className: "u-component-spacing" },
            React__default.createElement(layout.Column, { xs: 24 },
                React__default.createElement(FormTitle, { isFullyPaperless: !Object.keys(values).some(function (key) { return values[key].active === false; }), isUpdatingPreferences: isUpdatingPreferences, onPaperFreeClick: function () {
                        handleChange(makePaperFree(values));
                    } }))),
        React__default.createElement(layout.Row, null,
            React__default.createElement(layout.Column, { xs: 24 },
                React__default.createElement(PreferenceOptionList, { options: values, onPreferenceChange: handleChange, disabled: isUpdatingPreferences }))),
        React__default.createElement(layout.Row, null,
            React__default.createElement(layout.Column, { xs: 24 },
                React__default.createElement(buttons.Button, { id: "submit-preferences", type: "button", isLoading: isUpdatingPreferences, display: "primary", onClick: handleSubmit, disabled: (!isDirty || isUpdatingPreferences) && !autoCheck }, "Confirm preferences")))));
};
var mapStateToProps$5 = function (state) { return ({
    session: state.documentManagement.session
}); };
var RenderForm = redux.compose(reactRedux.connect(mapStateToProps$5), withContent(content, mapPropsToBrand), withBeforeUnload(function (props) { return props.nativePromptBeforeUnload && props.isDirty; }))(RenderFormInternal);

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = _assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;

var _ListCache = ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache;
  this.size = 0;
}

var _stackClear = stackClear;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas;

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/** Built-in value references. */
var Symbol = _root.Symbol;

var _Symbol = Symbol;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag$1 && symToStringTag$1 in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];

var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
    objectProto$2 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$1.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}

var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}

var _getNative = getNative;

/* Built-in method references that are verified to be native. */
var Map = _getNative(_root, 'Map');

var _Map = Map;

/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');

var _nativeCreate = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}

var _hashClear = hashClear;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$2.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? (data[key] !== undefined) : hasOwnProperty$3.call(data, key);
}

var _hashHas = hashHas;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (_nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;

var _Hash = Hash;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash,
    'map': new (_Map || _ListCache),
    'string': new _Hash
  };
}

var _mapCacheClear = mapCacheClear;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}

var _mapCacheGet = mapCacheGet;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;

var _MapCache = MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;

var _Stack = Stack;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED$2);
  return this;
}

var _setCacheAdd = setCacheAdd;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new _MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd;
SetCache.prototype.has = _setCacheHas;

var _SetCache = SetCache;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new _SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!_arraySome(other, function(othValue, othIndex) {
            if (!_cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays;

/** Built-in value references. */
var Uint8Array = _root.Uint8Array;

var _Uint8Array = Uint8Array;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new _Uint8Array(object), new _Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq_1(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = _mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1;
      convert || (convert = _setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$1;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = _equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

var isArray_1 = isArray;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

var stubArray_1 = stubArray;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$5.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray_1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

var _getSymbols = getSymbols;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}

var _baseIsArguments = baseIsArguments;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function() { return arguments; }()) ? _baseIsArguments : function(value) {
  return isObjectLike_1(value) && hasOwnProperty$4.call(value, 'callee') &&
    !propertyIsEnumerable$1.call(value, 'callee');
};

var isArguments_1 = isArguments;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

var isBuffer_1 = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? _root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse_1;

module.exports = isBuffer;
});

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

var isLength_1 = isLength;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag$1 = '[object Map]',
    numberTag$1 = '[object Number]',
    objectTag = '[object Object]',
    regexpTag$1 = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag$1 = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] =
typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag$1] =
typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag$1] = typedArrayTags[numberTag$1] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag$1] =
typedArrayTags[setTag$1] = typedArrayTags[stringTag$1] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike_1(value) &&
    isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}

var _baseIsTypedArray = baseIsTypedArray;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && _freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
});

/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;

var isTypedArray_1 = isTypedArray;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
      isArg = !isArr && isArguments_1(value),
      isBuff = !isArr && !isArg && isBuffer_1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? _baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$5.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           _isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$8;

  return value === proto;
}

var _isPrototype = isPrototype;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);

var _nativeKeys = nativeKeys;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$9.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$6.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}

var isArrayLike_1 = isArrayLike;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}

var keys_1 = keys;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return _baseGetAllKeys(object, keys_1, _getSymbols);
}

var _getAllKeys = getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$a.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2,
      objProps = _getAllKeys(object),
      objLength = objProps.length,
      othProps = _getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$7.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects;

/* Built-in method references that are verified to be native. */
var DataView = _getNative(_root, 'DataView');

var _DataView = DataView;

/* Built-in method references that are verified to be native. */
var Promise = _getNative(_root, 'Promise');

var _Promise = Promise;

/* Built-in method references that are verified to be native. */
var Set = _getNative(_root, 'Set');

var _Set = Set;

/* Built-in method references that are verified to be native. */
var WeakMap = _getNative(_root, 'WeakMap');

var _WeakMap = WeakMap;

/** `Object#toString` result references. */
var mapTag$2 = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$2 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$2 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView),
    mapCtorString = _toSource(_Map),
    promiseCtorString = _toSource(_Promise),
    setCtorString = _toSource(_Set),
    weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$2) ||
    (_Map && getTag(new _Map) != mapTag$2) ||
    (_Promise && getTag(_Promise.resolve()) != promiseTag) ||
    (_Set && getTag(new _Set) != setTag$2) ||
    (_WeakMap && getTag(new _WeakMap) != weakMapTag$1)) {
  getTag = function(value) {
    var result = _baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? _toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$2;
        case mapCtorString: return mapTag$2;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$2;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var _getTag = getTag;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    objectTag$2 = '[object Object]';

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$b.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray_1(object),
      othIsArr = isArray_1(other),
      objTag = objIsArr ? arrayTag$1 : _getTag(object),
      othTag = othIsArr ? arrayTag$1 : _getTag(other);

  objTag = objTag == argsTag$2 ? objectTag$2 : objTag;
  othTag = othTag == argsTag$2 ? objectTag$2 : othTag;

  var objIsObj = objTag == objectTag$2,
      othIsObj = othTag == objectTag$2,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer_1(object)) {
    if (!isBuffer_1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new _Stack);
    return (objIsArr || isTypedArray_1(object))
      ? _equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : _equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$3)) {
    var objIsWrapped = objIsObj && hasOwnProperty$8.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$8.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new _Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new _Stack);
  return _equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike_1(value) && !isObjectLike_1(other))) {
    return value !== value && other !== other;
  }
  return _baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

var _baseIsEqual = baseIsEqual;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return _baseIsEqual(value, other);
}

var isEqual_1 = isEqual;

var ManagedForm = /** @class */ (function (_super) {
    __extends(ManagedForm, _super);
    function ManagedForm(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            values: __assign({}, props.initialValues),
            isDirty: false
        };
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        return _this;
    }
    ManagedForm.prototype.handleChange = function (value) {
        var _this = this;
        this.setState(function (prevState) { return ({
            // Weird typescript issue with spread operator: https://github.com/Microsoft/TypeScript/issues/26412
            values: Object.assign({}, prevState.values, value),
            isDirty: !isEqual_1(_this.props.initialValues, Object.assign({}, prevState.values, value))
        }); });
    };
    ManagedForm.prototype.handleSubmit = function () {
        this.props.onSubmit(this.state.values);
        this.setState(function (prevState) { return ({
            isDirty: false
        }); });
    };
    ManagedForm.prototype.render = function () {
        return (React__default.createElement("div", null, this.props.render(__assign({}, this.state, { handleSubmit: this.handleSubmit, handleChange: this.handleChange }))));
    };
    return ManagedForm;
}(React.Component));

var Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Form;
}(ManagedForm));
var PreferenceForm = /** @class */ (function (_super) {
    __extends(PreferenceForm, _super);
    function PreferenceForm(props) {
        var _this = _super.call(this, props) || this;
        _this.handlePreferenceFormChange = _this.handlePreferenceFormChange.bind(_this);
        _this.state = {
            initialPreferences: props.preferenceOptions,
            newPreferences: {}
        };
        return _this;
    }
    PreferenceForm.prototype.handlePreferenceFormChange = function (preference, callback) {
        var _this = this;
        this.setState({
            newPreferences: Object.assign(__assign({}, this.state.initialPreferences, this.state.newPreferences), preference)
        }, function () {
            // ToDo - add a deep comparison, this is cheap and nasty
            var initial = JSON.stringify(_this.state.initialPreferences);
            var newPrefs = JSON.stringify(_this.state.newPreferences);
            _this.props.handlePreferencesUpdate(initial !== newPrefs);
            return callback();
        });
    };
    PreferenceForm.prototype.render = function () {
        var _this = this;
        var _a = this.props, onSubmit = _a.onSubmit, preferenceOptions = _a.preferenceOptions, isUpdatingPreferences = _a.isUpdatingPreferences, autoCheck = _a.autoCheck, handlePreferencesUpdate = _a.handlePreferencesUpdate, nativePromptBeforeUnload = _a.nativePromptBeforeUnload;
        return (React__default.createElement(Form, { initialValues: preferenceOptions, onSubmit: onSubmit, render: function (_a) {
                var values = _a.values, handleChange = _a.handleChange, handleSubmit = _a.handleSubmit, isDirty = _a.isDirty;
                var props = {
                    values: values,
                    handleChange: function (pref) {
                        _this.handlePreferenceFormChange(pref, function () { return handleChange(pref); });
                    },
                    handleSubmit: function (pref) {
                        handleSubmit(pref);
                        handlePreferencesUpdate(false);
                    },
                    isDirty: isDirty,
                    nativePromptBeforeUnload: nativePromptBeforeUnload,
                    isUpdatingPreferences: isUpdatingPreferences,
                    autoCheck: autoCheck,
                };
                return React__default.createElement(RenderForm, __assign({}, props));
            } }));
    };
    return PreferenceForm;
}(React__default.Component));

var CentredModal = function (_a) {
    var children = _a.children, isOpen = _a.isOpen, onClose = _a.onClose, _b = _a.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _b === void 0 ? true : _b;
    return (React__default.createElement(modals.Modal, { isOpen: isOpen, onRequestClose: onClose, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick },
        React__default.createElement("div", { className: "u-flex u-flex-direction-column u-flex-align-items-center u-padding-3" }, children)));
};

var DigitalStatementPreviewModal = /** @class */ (function (_super) {
    __extends(DigitalStatementPreviewModal, _super);
    function DigitalStatementPreviewModal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isOpen: false
        };
        _this.handleOnClose = _this.handleOnClose.bind(_this);
        _this.handleOpenClick = _this.handleOpenClick.bind(_this);
        return _this;
    }
    DigitalStatementPreviewModal.prototype.handleOnClose = function () {
        this.setState({
            isOpen: false
        });
    };
    DigitalStatementPreviewModal.prototype.handleOpenClick = function () {
        this.setState({
            isOpen: true
        });
    };
    DigitalStatementPreviewModal.prototype.render = function () {
        var brand = this.props.brandID.toLowerCase();
        if (brand === "dyb") {
            brand = "b";
        }
        return (React__default.createElement("div", null,
            React__default.createElement(buttons.Button, { id: "open-preview", className: "u-padding-left-0", onClick: this.handleOpenClick }, "View a sample digital statement"),
            React__default.createElement(CentredModal, { onClose: this.handleOnClose, isOpen: this.state.isOpen },
                React__default.createElement(headings.SectionHeading, null, "Just as you're used to - keeping things familiar"),
                React__default.createElement(layout.CenterImageContainer, { image: React__default.createElement("img", { style: { flex: 1, maxWidth: "85vw", maxHeight: "70vh" }, alt: "statement for " + brand, src: "../images/" + brand + "/statement_image_" + brand + "@3x.jpg" }) }),
                React__default.createElement(text.TextBody, null, "Example digital statement"),
                React__default.createElement(buttons.Button, { id: "close-preview", display: "primary", onClick: this.handleOnClose }, "Close"))));
    };
    return DigitalStatementPreviewModal;
}(React.Component));

var SuccessModal = function (_a) {
    var onDismissClick = _a.onDismissClick, isOpen = _a.isOpen, title = _a.title, subTitle = _a.subTitle;
    return (React__default.createElement(modals.CentredModal, { isOpen: isOpen, onClose: onDismissClick },
        React__default.createElement(layout.CenterImageContainer, { image: React__default.createElement(iconography.Icon, { iconType: "TickOutlineCircleFilledLarge", size: "lg", color: "status-active" }) }),
        React__default.createElement(text.Title, { size: "h2", className: "u-padding-2" }, title),
        React__default.createElement(text.TextBody, null, subTitle),
        React__default.createElement(buttons.Button, { width: "sm", type: "button", display: "primary", onClick: onDismissClick }, "Ok")));
};

var PaperlessPreferences = function (_a) {
    var handlePreferencesUpdate = _a.handlePreferencesUpdate, preferenceOptions = _a.preferenceOptions, onSubmit = _a.onSubmit, onDismissSuccessModalClick = _a.onDismissSuccessModalClick, hasLoaded = _a.hasLoaded, isUpdatingPreferences = _a.isUpdatingPreferences, isSuccessModalOpen = _a.isSuccessModalOpen, autoCheck = _a.autoCheck, nativePromptBeforeUnload = _a.nativePromptBeforeUnload, brandID = _a.brandID;
    var loadingLocalTakeover = (React__default.createElement(takeovers.LoadingLocalTakeover, { title: "Loading preferences", show: !hasLoaded }, hasLoaded ? (React__default.createElement(PreferenceForm, { autoCheck: autoCheck, onSubmit: onSubmit, isUpdatingPreferences: isUpdatingPreferences, preferenceOptions: preferenceOptions, handlePreferencesUpdate: handlePreferencesUpdate, nativePromptBeforeUnload: nativePromptBeforeUnload })) : (React__default.createElement("div", { style: { minHeight: "200px", color: "white" } }))));
    var successModal = (React__default.createElement(SuccessModal, { isOpen: isSuccessModalOpen, onDismissClick: onDismissSuccessModalClick, title: "Your preferences have been updated", subTitle: "If a document has just been issued it may be the following month before your updated preferences take effect." }));
    var pageTitle = "Paper-free preferences";
    if (!brandID || brandID.toLowerCase() === "vm") {
        return (React__default.createElement(cards.Card, null,
            React__default.createElement(headings.PageHeading, null, pageTitle),
            React__default.createElement(PreferenceInfo, null),
            React__default.createElement(DigitalStatementPreviewModal, { brandID: brandID }),
            React__default.createElement("br", null),
            loadingLocalTakeover,
            successModal));
    }
    return (React__default.createElement("div", null,
        React__default.createElement(layout.Row, { className: "u-component-spacing" },
            React__default.createElement(layout.Column, { xs: 24 },
                React__default.createElement(cards.Card, { title: pageTitle },
                    React__default.createElement(PreferenceInfo, null)))),
        React__default.createElement(layout.Row, { className: "u-component-spacing" },
            React__default.createElement(layout.Column, { xs: 24 },
                React__default.createElement(DigitalStatementPreviewModal, { brandID: brandID }))),
        loadingLocalTakeover,
        successModal));
};

var getPreferences$1 = function (state) { return state.documentManagement.preferences; };
var getAccounts$1 = function (state) { return state.documentManagement.accounts; };
var getAutoCheck = function (_, props) { return props.autoCheck; };
var nonPaperlessBlurb = content.default.nonPaperlessBlurb;
var getPreferenceOptions = reselect.createSelector([getPreferences$1, getAccounts$1, getAutoCheck], function (preferences, accounts, autoCheck) {
    var accountPrefs = accounts.reduce(function (preferenceOptions, account) {
        var _a;
        return (__assign({}, preferenceOptions, (_a = {}, _a[account.id] = __assign({}, (!account.actions_available["/account/statements/read"] &&
            !account.actions_available["/account/preferences/paperstatementoptout"] && { blurb: nonPaperlessBlurb }), { title: getAccountName(account), paperlessAvailable: account.actions_available["/account/statements/read"] === true, accountSpecific: true, active: preferences.communication_preferences[0].accounts.some(function (a) { return a.id === account.id; }) ||
                autoCheck ||
                false, subTitle: formatAccountAndSortCodeToPipe(account.number) }), _a)));
    }, {});
    return __assign({}, accountPrefs, { otherDocuments: {
            blurb: content.default.paperlessBlurb,
            title: "Other correspondence",
            accountSpecific: false,
            active: preferences.communication_preferences[0].value === "Y",
            paperlessAvailable: true,
            subTitle: "",
        } });
});

var mapPreferenceOptionsToRequest = function (preferenceOptions) {
    var accountPrefs = Object.keys(preferenceOptions)
        .filter(function (key) { return preferenceOptions[key].active; })
        .map(function (accountId) { return ({
        id: accountId,
    }); });
    var active = preferenceOptions.otherDocuments.active;
    return {
        communication_preferences: [
            {
                accounts: accountPrefs.filter(function (pref) { return pref.id !== "otherDocuments"; }),
                type: "Paperless",
                value: active ? "Y" : "N",
            },
        ],
    };
};

var PaperlessPreferencesContainer = /** @class */ (function (_super) {
    __extends(PaperlessPreferencesContainer, _super);
    function PaperlessPreferencesContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleDismissSuccessModalClick = _this.handleDismissSuccessModalClick.bind(_this);
        if (props.hasReceivedAccounts === false) {
            props.getAccounts();
        }
        if (props.hasReceivedPreferences === false) {
            props.getPreferences();
        }
        return _this;
    }
    PaperlessPreferencesContainer.prototype.handleSubmit = function (preferenceOptions) {
        this.props.updatePreferences(mapPreferenceOptionsToRequest(preferenceOptions));
    };
    PaperlessPreferencesContainer.prototype.handleDismissSuccessModalClick = function () {
        this.props.closeModal(PREFS_UPDATED_SUCCESSFULLY);
    };
    PaperlessPreferencesContainer.prototype.render = function () {
        var _a = this.props, preferenceOptions = _a.preferenceOptions, hasReceivedAccounts = _a.hasReceivedAccounts, hasReceivedPreferences = _a.hasReceivedPreferences, isUpdatingPreferences = _a.isUpdatingPreferences, autoCheck = _a.autoCheck, isSuccessModalOpen = _a.isSuccessModalOpen, brandID = _a.brandID, nativePromptBeforeUnload = _a.nativePromptBeforeUnload;
        return (React__default.createElement(PaperlessPreferences, { handlePreferencesUpdate: this.props.handlePreferencesUpdate, brandID: brandID, preferenceOptions: preferenceOptions, onSubmit: this.handleSubmit, hasLoaded: hasReceivedAccounts && hasReceivedPreferences, isUpdatingPreferences: isUpdatingPreferences, autoCheck: autoCheck, onDismissSuccessModalClick: this.handleDismissSuccessModalClick, isSuccessModalOpen: isSuccessModalOpen, nativePromptBeforeUnload: nativePromptBeforeUnload }));
    };
    return PaperlessPreferencesContainer;
}(React.Component));
var hasReceivedAccountsSelector$1 = buildHasReceivedSelector(GET_ACCOUNTS);
var hasReceivedPreferencesSelector = buildHasReceivedSelector(GET_PREFERENCES);
var isUpdatingPreferencesSelector = buildHasApiCallInProgress(UPDATE_PREFERENCES);
var actionCreators$4 = {
    getAccounts: getAccounts,
    getPreferences: getPreferences,
    updatePreferences: updatePreferences,
    closeModal: closeModal
};
var isSuccessModalOpenSelector = createIsModalOpenSelector(PREFS_UPDATED_SUCCESSFULLY);
var mapStateToProps$6 = function (state, props) {
    return {
        hasReceivedAccounts: hasReceivedAccountsSelector$1(state),
        hasReceivedPreferences: hasReceivedPreferencesSelector(state),
        isUpdatingPreferences: isUpdatingPreferencesSelector(state),
        isSuccessModalOpen: isSuccessModalOpenSelector(state),
        preferenceOptions: getPreferenceOptions(state, {
            autoCheck: props.autoCheck
        }),
        autoCheck: props.autoCheck
    };
};
var PaperlessPreferencesContainer$1 = redux.compose(reactRedux.connect(mapStateToProps$6, actionCreators$4))(PaperlessPreferencesContainer);

var WithPreferenceCard = function (_a) {
    var session = _a.session, children = _a.children;
    return (React__default.createElement(layout.Container, null,
        React__default.createElement(layout.Row, { className: "u-component-spacing" }, children),
        React__default.createElement(layout.Row, null,
            React__default.createElement(PreferenceCardContainer$1, { session: session }))));
};
var Routes = function (_a) {
    var session = _a.session, client = _a.client, handlePreferencesUpdate = _a.handlePreferencesUpdate;
    return (React__default.createElement(reactRouter.Switch, null,
        React__default.createElement(reactRouter.Route, { path: "/:bankId/documents", exact: true, render: function (props) { return (React__default.createElement(WithPreferenceCard, { session: session },
                React__default.createElement(ListViewContainer$1, __assign({}, props, { session: session, client: client })))); } }),
        React__default.createElement(reactRouter.Route, { path: "/digital-statements/select-account", exact: true, render: function (props) { return (React__default.createElement(layout.Container, null,
                React__default.createElement(AccountSelectorContainer$1, __assign({}, props)))); } }),
        React__default.createElement(reactRouter.Route, { path: "/:bankId/documents/error", exact: true, render: function (props) { return React__default.createElement(DocumentFailedToLoadError, __assign({ brand: session.brand, onCloseClick: function () { return window.close(); } }, props)); } }),
        React__default.createElement(reactRouter.Route, { path: "/:bankId/documents/:documentId", exact: true, render: function (props) { return React__default.createElement(DocumentView$1, __assign({}, props, { session: session })); } }),
        React__default.createElement(reactRouter.Route, { path: "/:bankId/preferences", exact: true, render: function (props) { return (React__default.createElement(layout.Container, { size: "lg", className: "u-component-spacing" },
                React__default.createElement(PaperlessPreferencesContainer$1, { handlePreferencesUpdate: handlePreferencesUpdate, autoCheck: false, brandID: session.brand, nativePromptBeforeUnload: true }))); } })));
};

var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App(props) {
        return _super.call(this, props) || this;
    }
    App.prototype.getChildContext = function () {
        return { clientContext: this.props.client };
    };
    App.prototype.render = function () {
        var _a = this.props, store = _a.store, session = _a.session, client = _a.client;
        return (React.createElement(reactRouterDom.BrowserRouter, null,
            React.createElement(themes.WebUIThemeProvider, { brandID: session.brand },
                React.createElement(reactRedux.Provider, { store: store },
                    React.createElement(Routes, { session: session, client: client })))));
    };
    App.childContextTypes = {
        clientContext: PropTypes.shape({
            client: PropTypes.shape({
                app_title: PropTypes.string
            })
        })
    };
    return App;
}(React.Component));

var Routes$1 = function (_a) {
    var session = _a.session, client = _a.client;
    return (React__default.createElement(reactRouter.Switch, null,
        React__default.createElement(reactRouter.Route, { path: "/documents", exact: true, render: function (props) { return React__default.createElement(ListViewContainer$1, __assign({}, props, { session: session, client: client })); } }),
        React__default.createElement(reactRouter.Route, { path: "/digital-statements/select-account", exact: true, render: function (props) { return (React__default.createElement(layout.Container, null,
                React__default.createElement(AccountSelectorContainer$1, __assign({}, props)))); } }),
        React__default.createElement(reactRouter.Route, { path: "/:bankId/documents/:documentId", exact: true, component: DocumentView }),
        React__default.createElement(reactRouter.Redirect, { from: "/", to: "/documents" })));
};

var getContextHeaders = function (clientContext, version) {
    var _a;
    return (_a = {},
        _a["x-bpi-client-context"] = JSON.stringify(clientContext),
        _a);
};

var getAuthorizationHeader = function (session) { return ({
    Authorization: "Bearer " + session.access_token
}); };

var handleException = function (response) {
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response;
};
var fetchWithExceptionHandling = function (input, init) { return fetch(input, init).then(handleException); };

var defaultSearch = {
    filter_info: [
        {
            search_params: {}
        }
    ]
};
var buildGetDocuments = function (clientContext, session, environment) { return function (search) {
    if (search === void 0) { search = defaultSearch; }
    return fetchWithExceptionHandling((environment.apiBaseUrlPAAS ? environment.apiBaseUrlPAAS : environment.apiBaseUrl) + "/user/documentlibrary/search", {
        method: "POST",
        mode: "cors",
        headers: __assign({ "Content-Type": "application/json", Accept: "application/json" }, getContextHeaders(clientContext), getAuthorizationHeader(session)),
        body: JSON.stringify(search)
    }).then(function (res) {
        return res.json();
    });
}; };

var buildGetDocumentById = function (clientContext, session, environment) { return function (_a) {
    var id = _a.id;
    return fetchWithExceptionHandling((environment.apiBaseUrlPAAS ? environment.apiBaseUrlPAAS : environment.apiBaseUrl) + "/banks/" + session.bank_id + "/documentlibrary/" + id, {
        method: "GET",
        headers: __assign({}, getContextHeaders(clientContext), getAuthorizationHeader(session), { "Content-Disposition": "inline;", "Content-Type": "application/pdf" })
    }).then(function (res) { return res.blob(); });
}; };

var buildGetAccounts = function (clientContext, session, environment) { return function () {
    return fetch((environment.apiBaseUrlPAAS ? environment.apiBaseUrlPAAS : environment.apiBaseUrl) + "/banks/" + session.bank_id + "/accounts/default", {
        method: "GET",
        mode: "cors",
        headers: __assign({ "Content-Type": "application/json", Accept: "application/json" }, getContextHeaders(clientContext), getAuthorizationHeader(session))
    }).then(function (res) {
        return res.json();
    });
}; };

var buildGetPreferences = function (clientContext, session, environment) { return function () {
    return fetchWithExceptionHandling((environment.apiBaseUrlPAAS ? environment.apiBaseUrlPAAS : environment.apiBaseUrl) + "/user/preferences", {
        method: "GET",
        mode: "cors",
        headers: __assign({ "Content-Type": "application/json", Accept: "application/json", "x-bpi-version": "0.8.0" }, getContextHeaders(clientContext), getAuthorizationHeader(session))
    }).then(function (res) {
        return res.json();
    });
}; };
var buildUpdatePreferences = function (clientContext, session, environment) { return function (body) {
    return fetchWithExceptionHandling((environment.apiBaseUrlPAAS ? environment.apiBaseUrlPAAS : environment.apiBaseUrl) + "/user/preferences", {
        method: "PUT",
        mode: "cors",
        headers: __assign({ "Content-Type": "application/json", Accept: "application/json", "x-bpi-version": "0.8.0" }, getContextHeaders(clientContext), getAuthorizationHeader(session)),
        body: JSON.stringify(body)
    }).then(function (res) {
        return res.json();
    });
}; };

var Api = /** @class */ (function () {
    function Api(clientContext, session, environment) {
        this.getDocuments = buildGetDocuments(clientContext, session, environment);
        this.getDocumentById = buildGetDocumentById(clientContext, session, environment);
        this.getAccounts = buildGetAccounts(clientContext, session, environment);
        this.getPreferences = buildGetPreferences(clientContext, session, environment);
        this.updatePreferences = buildUpdatePreferences(clientContext, session, environment);
    }
    return Api;
}());

var buildMiddleware = function (clientContext, session, environment, dependencies) {
    if (dependencies === void 0) { dependencies = {
        api: new Api(clientContext, session, environment),
        native: native
    }; }
    return thunk.withExtraArgument(dependencies);
};

var getStaffHeaders = function (session) { return ({
    "x-bpi-customer-id": session.customer_number,
    "x-bpi-trust-level": session.accessTokenScope || "40",
    "x-bpi-trust-created-dt": session.scopeCreatedDate || moment().format("YYYY-MM-DDTHH:mm:ss"),
    "x-bpi-customer-bank-id": session.bank_id
}); };

var defaultSearch$1 = {
    filter_info: [
        {
            search_params: {}
        }
    ]
};
var buildGetDocuments$1 = function (clientContext, session, environment) { return function (search) {
    if (search === void 0) { search = defaultSearch$1; }
    return fetchWithExceptionHandling(environment.apiBaseUrl + "/banks/" + session.bank_id + "/documentlibrary/search", {
        method: "POST",
        body: JSON.stringify(search),
        headers: __assign({ "Content-Type": "application/json", Accept: "application/json" }, getContextHeaders(clientContext), getAuthorizationHeader(session), getStaffHeaders(session))
    })
        .then(function (res) {
        return res.json();
    })
        .catch(function (err) { return new Error(err); });
}; };

var buildGetDocumentById$1 = function (clientContext, session, environment) { return function (_a) {
    var id = _a.id;
    return fetchWithExceptionHandling(environment.apiBaseUrl + "/banks/" + session.bank_id + "/documentlibrary/" + id, {
        method: "GET",
        headers: __assign({}, getContextHeaders(clientContext), getAuthorizationHeader(session), getStaffHeaders(session), { "Content-Disposition": "inline;", "Content-Type": "application/pdf" })
    }).then(function (res) { return res.blob(); });
}; };

var buildGetPreferences$1 = function (clientContext, session, environment) { return function () {
    return fetchWithExceptionHandling(environment.apiBaseUrl + "/user/preferences", {
        method: "GET",
        mode: "cors",
        headers: __assign({ "Content-Type": "application/json", Accept: "application/json", "x-bpi-version": "0.8.0" }, getContextHeaders(clientContext), getAuthorizationHeader(session), getStaffHeaders(session))
    }).then(function (res) {
        return res.json();
    });
}; };

var Api$1 = /** @class */ (function () {
    function Api(clientContext, session, environment) {
        this.getDocuments = buildGetDocuments$1(clientContext, session, environment);
        this.getDocumentById = buildGetDocumentById$1(clientContext, session, environment);
        this.getAccounts = buildGetAccounts(clientContext, session, environment);
        this.getPreferences = buildGetPreferences$1(clientContext, session, environment);
        this.updatePreferences = buildUpdatePreferences(clientContext, session, environment);
    }
    return Api;
}());

var devToolsExtension = (!process.env.NODE_ENV || process.env.NODE_ENV === "development") && window.__REDUX_DEVTOOLS_EXTENSION__;
var createStoreWithMiddleware = function (clientContext, session, environment) {
    return redux.compose(redux.applyMiddleware(buildMiddleware(clientContext, session, environment, {
        api: new Api$1(clientContext, session, environment),
        native: native
    })), devToolsExtension ? devToolsExtension() : function (next) { return next; })(redux.createStore);
};
var configureStore = function (clientContext, session, environment) {
    var finalReducer = redux.combineReducers({
        documentManagement: reducer
    });
    var store = createStoreWithMiddleware(clientContext, session, environment)(finalReducer, { documentManagement: initialState$4 });
    return store;
};

var buildSession = function (config) { return ({
    access_token: config.accessToken,
    bank_id: config.bankId,
    brand: config.brandId,
    state: config.scope,
    customer_id: config.customerId,
    customer_number: config.customerNumber,
    accessTokenScope: config.scope,
    scopeCreatedDate: config.scopeCreatedDate
}); };
var App$1 = /** @class */ (function (_super) {
    __extends(App, _super);
    function App(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            clientContext: buildClientContext(_this.props.config.appTitle),
            session: buildSession(_this.props.config),
            env: {
                apiBaseUrl: _this.props.config.ibApiUrl + "/ibapi/v2"
            }
        };
        _this.store = configureStore(_this.state.clientContext, _this.state.session, _this.state.env);
        return _this;
    }
    App.prototype.getChildContext = function () {
        return { clientContext: this.state.clientContext };
    };
    App.prototype.render = function () {
        var _a = this.state, session = _a.session, clientContext = _a.clientContext;
        return (React.createElement(reactRouterDom.MemoryRouter, null,
            React.createElement(layout.PageLayout, null,
                React.createElement(reactRedux.Provider, { store: this.store },
                    React.createElement(themes.WebUIThemeProvider, { brandID: session.brand },
                        React.createElement(layout.Container, { size: "md" },
                            React.createElement(Routes$1, { session: session, client: clientContext })))))));
    };
    App.childContextTypes = {
        clientContext: PropTypes.shape({
            client: PropTypes.shape({
                app_title: PropTypes.string
            })
        })
    };
    return App;
}(React.Component));

var devToolsExtension$1 = (!process.env.NODE_ENV || process.env.NODE_ENV === "development") && window.__REDUX_DEVTOOLS_EXTENSION__;
var createStoreWithMiddleware$1 = function (clientContext, session, environment) {
    return redux.compose(redux.applyMiddleware(buildMiddleware(clientContext, session, environment)), devToolsExtension$1 ? devToolsExtension$1() : function (next) { return next; })(redux.createStore);
};
var configureStore$1 = function (clientContext, session, environment) {
    var finalReducer = redux.combineReducers({
        documentManagement: reducer
    });
    var store = createStoreWithMiddleware$1(clientContext, session, environment)(finalReducer, { documentManagement: initialState$4 });
    return store;
};

var App$2 = /** @class */ (function (_super) {
    __extends(App, _super);
    function App(props) {
        return _super.call(this, props) || this;
    }
    App.prototype.getChildContext = function () {
        return { clientContext: this.props.client };
    };
    App.prototype.render = function () {
        var _a = this.props, session = _a.session, client = _a.client, environment = _a.environment, autoCheck = _a.autoCheck, handlePreferencesUpdate = _a.handlePreferencesUpdate, nativePromptBeforeUnload = _a.nativePromptBeforeUnload;
        var store = configureStore$1(client, session, environment);
        return (React.createElement(layout.PageLayout, null,
            React.createElement(themes.WebUIThemeProvider, { brandID: session.brand },
                React.createElement(reactRedux.Provider, { store: store },
                    React.createElement(layout.Container, { size: "lg", className: "u-component-spacing" },
                        React.createElement(PaperlessPreferencesContainer$1, { handlePreferencesUpdate: handlePreferencesUpdate ? handlePreferencesUpdate : function () { return true; }, autoCheck: autoCheck, nativePromptBeforeUnload: nativePromptBeforeUnload, brandID: session.brand }))))));
    };
    App.childContextTypes = {
        clientContext: PropTypes.shape({
            client: PropTypes.shape({
                app_title: PropTypes.string
            })
        })
    };
    return App;
}(React.Component));

var TransitionPrompt = function (_a) {
    var _b = _a.canDismiss, canDismiss = _b === void 0 ? true : _b, showTransitionPrompt = _a.showTransitionPrompt, handleRequestClose = _a.handleRequestClose, handleCancelConfirmation = _a.handleCancelConfirmation, getContent = _a.getContent;
    return (React__default.createElement(modals.Modal, { size: "md", title: canDismiss ? getContent("leaveConfirmationManageTitle") : getContent("leaveConfirmationAutoTitle"), isOpen: showTransitionPrompt, onRequestClose: handleRequestClose, shouldCloseOnOverlayClick: canDismiss },
        React__default.createElement(text.TextBody, null, canDismiss ? getContent("leaveConfirmationManageBody") : getContent("leaveConfirmationAutoBody")),
        React__default.createElement(buttons$1.ButtonGroup, null,
            canDismiss && (React__default.createElement(buttons.Button, { id: "discard", display: "secondary", onClick: handleRequestClose }, getContent("leaveNoSaveButton"))),
            React__default.createElement(buttons.Button, { id: "confirm", display: "primary", onClick: handleCancelConfirmation }, getContent("leaveSaveButton")))));
};
var TransitionPrompt$1 = redux.compose(withContent(content, function () { return ""; }))(TransitionPrompt);

var DocumentDownloadLink = /** @class */ (function (_super) {
    __extends(DocumentDownloadLink, _super);
    function DocumentDownloadLink(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = function (event) {
            event.preventDefault();
            var _a = _this.props, isLoading = _a.isLoading, documentName = _a.documentName;
            if (!isLoading && supportsIEDownload()) {
                _this.props.getDocumentById(_this.props.documentId).then(function (blob) { return window.navigator.msSaveOrOpenBlob(blob, documentName); });
            }
        };
        return _this;
    }
    DocumentDownloadLink.prototype.componentWillUnmount = function () {
        this.props.clearCurrentDocument();
    };
    DocumentDownloadLink.prototype.render = function () {
        return React__default.createElement(navigation.DocumentLink, { linkText: this.props.documentName, onClick: this.onClick, hasIcon: true });
    };
    return DocumentDownloadLink;
}(React__default.Component));
var mapDispatchToProps$1 = function (dispatch) {
    return {
        clearCurrentDocument: clearCurrentDocument,
        getDocumentById: function (id) {
            return dispatch(getDocumentById({ id: id }));
        }
    };
};
var mapStateToProps$7 = function (state) { return ({
    blob: getBlobForCurrentDocument(state),
    isLoading: hasApiCallInProgress(state)
}); };
var DocumentDownloadLink$1 = reactRedux.connect(mapStateToProps$7, mapDispatchToProps$1)(DocumentDownloadLink);

var utils = {
    withNativeBridge: withNativeBridge,
    withBreakpoints: withBreakpoints,
    native: native
};
var dependencies = {
    native: native,
    Api: Api,
    InternalApi: Api$1
};

exports.AccountSelectorContainer = AccountSelectorContainer$1;
exports.AdvisorApp = App$1;
exports.App = App;
exports.DocumentDownloadLink = DocumentDownloadLink$1;
exports.DocumentListContainer = DocumentListContainer$1;
exports.DocumentView = DocumentView$1;
exports.ListViewContainer = ListViewContainer$1;
exports.PaperlessPreferencesApp = App$2;
exports.PaperlessPreferencesContainer = PaperlessPreferencesContainer$1;
exports.PreferenceCardContainer = PreferenceCardContainer$1;
exports.TransitionPrompt = TransitionPrompt$1;
exports.actions = actions;
exports.buildMiddleware = buildMiddleware;
exports.dependencies = dependencies;
exports.reducer = reducer;
exports.selectors = selector;
exports.utils = utils;
